import { URL_baseRoute, getLocalStorageItem, createLegacyEndpoint, setLocalStorageItem, baseApiWithResponse, REST_RETRY_TIMEOUT, REST_RETRY_COUNT, baseApiWithoutResponse, legacyAlternativesOff, legacyAlternativesOn, intermediaryMatchingMandateLocalStorageKey, getCustomBrandConfig, getBrandHostname, isWindowUndefined, getSavedSearches, mockedBasicsKeys, originTypesToBeAbTested } from './chunk-DBIF5UGD.mjs';
import { SavedSearchDeviceType, SavedSearchOrigin, SavedSearchState, DeliveryTimeline, SearchType, AssistedLiving, SwimmingPool, Furnished, Garden, BuildState, BuildingAttic, Cellar, Elevator, KitchenEquipment, SpaceMeasureUnit, HasFee, DistributionSubType, DistributionType, EstateType, SavedSearchNotificationChannel, EnergyClass, ManagementUseFor, EstateSubType, LocationInBuilding, MandateType, VendorType, LocationGeometryCircleRadiusUnit, LocationGeometryTravelUnit, LocationGeometryTravelMode, EnergySource, EnergyHeatMethod, EnergyHeatForm, EnergyGeneration, ProjectType as ProjectType$1 } from '@aviv-saved-search/types';
import { BuildState as BuildState$1, UseFor, Furnished as Furnished$1, ProjectType, EstateSubType as EstateSubType$1, DistributionType as DistributionType$1, EstateType as EstateType$1, LocationType, FeatureType, CertificateOfEligibility, CommuteMode, ProviderType, LocationInBuildingType, EnergyType, DeliveryTimelineType } from '@aviv-search/types';
import { useState, useEffect } from 'react';
import { useAuthentication } from '@aviv-unified-frontend/runtime/authentication';
import circleToPolygon from 'circle-to-polygon';
import { mapSearchModelToQueryString } from '@aviv-search/transformers';

// src/Utils/auth/index.ts
var CLIENT_TOKEN = "auth.client.token";
var getParams = () => {
  const params = new URLSearchParams(window?.location?.search ?? "");
  const token = params.get("token");
  const ssid = params.get("ssid");
  const ac = params.get("ac");
  if (!token && !ssid) return null;
  return {
    token,
    ssid,
    ac
  };
};
var getLegacyParams = () => {
  const params = new URLSearchParams(window?.location?.search ?? "");
  const idalerteimmo = params.get("idalerteimmo");
  const identifieur = params.get("identifieur");
  if (!idalerteimmo || !identifieur) {
    return null;
  }
  return {
    idalert: idalerteimmo,
    identifier: identifieur
  };
};
var getBasicKey = (basicKeys, brand) => {
  switch (brand) {
    case "imn":
      return basicKeys.imn;
    case "iwt":
      return basicKeys.iwt;
    default:
      return basicKeys.imn;
  }
};
var getIWTAnonymousAuthToken = async ({ basicsKeys, brand, stage }) => {
  if (!basicsKeys) {
    throw new Error("basicsKey is required for anonymous authentication");
  }
  const savedToken = getLocalStorageItem(CLIENT_TOKEN);
  if (savedToken) {
    return savedToken;
  }
  const authKey = getBasicKey(basicsKeys, brand);
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Basic ${btoa(authKey)}`
  };
  const body = {
    grant_type: "client_credentials"
  };
  const fetchInit = {
    method: "POST",
    body: JSON.stringify(body),
    headers
  };
  const legacyEndpoint = createLegacyEndpoint(stage, brand);
  const url = legacyEndpoint + "/auth/oauth/token?grant_type=client_credentials";
  const response = await fetch(url, fetchInit);
  const responseJson = await response.json();
  setLocalStorageItem(CLIENT_TOKEN, responseJson.access_token);
  return responseJson.access_token;
};

// src/Utils/api/type.ts
var NotificationsTargetEnum = /* @__PURE__ */ ((NotificationsTargetEnum2) => {
  NotificationsTargetEnum2["EMAIL"] = "email";
  NotificationsTargetEnum2["RECOMMENDATIONS"] = "recommendations";
  return NotificationsTargetEnum2;
})(NotificationsTargetEnum || {});

// src/Utils/api/Anonymous/index.ts
var getAnonymousLegacyIWTSavedSearch = async (success, error, options) => {
  const { config, ssid } = options;
  const token = await getIWTAnonymousAuthToken(config);
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    `/savedsearch/v1/savedsearches?includeLookupNotifiedListings=true&referenceSavedSearchId=${ssid}`
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "GET",
    authenticationToken: token,
    retryOnFailure: true,
    retryCount: REST_RETRY_COUNT,
    retryDelay: REST_RETRY_TIMEOUT
  });
};
var deleteLegacyIWTSavedSearchesAnonymous = async (success, error, options) => {
  const { config, ssid } = options;
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    `/savedsearch/v1/savedsearches/${ssid}`
  );
  const token = await getIWTAnonymousAuthToken(config);
  return baseApiWithoutResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "DELETE",
    authenticationToken: token
  });
};
var getLegacySLGAnonymous = async (success, error, options) => {
  const { stage, params } = options;
  const { idalert, identifier } = params;
  const legacyEndpoint = createLegacyEndpoint(
    stage,
    "sl",
    `/userpreferences-bff/bff/v1/alerts?identifier=${identifier}&idalert=${idalert}`
  );
  return baseApiWithResponse(success, error, {
    url: legacyEndpoint,
    httpMethod: "GET"
  });
};
var updateLegacySLGNotificationsStateAnonymous = async (success, error, searchId, value, options) => {
  const { stage, params } = options;
  const { idalert, identifier } = params;
  const legacyEndpoint = createLegacyEndpoint(
    stage,
    "sl",
    value ? `/userpreferences-bff/bff/v1/alerts/${searchId}/subscribe?identifier=${identifier}&idalert=${idalert}` : `/userpreferences-bff/bff/v1/alerts/${searchId}/unsubscribe?identifier=${identifier}&idalert=${idalert}`
  );
  return baseApiWithoutResponse(success, error, {
    url: legacyEndpoint,
    httpMethod: "POST"
  });
};
var deleteLegacySLGAnonymousSavedSearch = async (success, error, searchId, options) => {
  const { stage, params } = options;
  const { idalert, identifier } = params;
  const legacyEndpoint = createLegacyEndpoint(
    stage,
    "sl",
    `/userpreferences-bff/bff/v1/alerts/${searchId}?identifier=${identifier}&idalert=${idalert}`
  );
  return baseApiWithoutResponse(success, error, {
    url: legacyEndpoint,
    httpMethod: "DELETE"
  });
};
var updateLegacyIWTNotificationsStateAnonymous = async (success, error, options) => {
  const { config, ssid, item, value, target } = options;
  const token = await getIWTAnonymousAuthToken(config);
  const emailChannel = item.baseAttributes.endpoints.find((ch) => ch.channelType === "EMAIL_MESSAGE");
  const newLegacyChannel = {
    channelType: "EMAIL_MESSAGE",
    displayName: emailChannel?.displayName ?? "",
    endpointResourceId: emailChannel?.endpointResourceId ?? "",
    notificationFrequency: {
      displayName: value ? "Sofot" : "Nie",
      intervalInMinutes: 0,
      type: value ? "IMMEDIATE" : "NEVER",
      referenceTimestamp: (/* @__PURE__ */ new Date()).toISOString()
    }
  };
  const criterias = {
    ...item?.baseAttributes?.searchCriteria,
    relaxedCriteria: !value ? legacyAlternativesOff : legacyAlternativesOn
  };
  const updateBody = target.includes("email" /* EMAIL */) && target.includes("recommendations" /* RECOMMENDATIONS */) ? {
    endpoints: [newLegacyChannel],
    searchCriteria: criterias
  } : target.includes("email" /* EMAIL */) ? {
    endpoints: [newLegacyChannel]
  } : {
    searchCriteria: criterias
  };
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    "/savedsearch/v1/savedsearchmodifications"
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "PUT",
    authenticationToken: token,
    body: { savedSearchId: ssid, ...updateBody }
  });
};
var updateLegacyNotificationsStatesAnonymous = async (success, error, options) => {
  const { config, ssid, item, value, target } = options;
  const token = await getIWTAnonymousAuthToken(config);
  const emailChannel = item.baseAttributes.endpoints.find((ch) => ch.channelType === "EMAIL_MESSAGE");
  const newLegacyChannel = {
    channelType: "EMAIL_MESSAGE",
    displayName: emailChannel?.displayName ?? "",
    endpointResourceId: emailChannel?.endpointResourceId ?? "",
    notificationFrequency: {
      displayName: value.email ? "Sofot" : "Nie",
      intervalInMinutes: 0,
      type: value.email ? "IMMEDIATE" : "NEVER",
      referenceTimestamp: (/* @__PURE__ */ new Date()).toISOString()
    }
  };
  const criterias = {
    ...item?.baseAttributes?.searchCriteria,
    relaxedCriteria: !value.recommendation ? legacyAlternativesOff : legacyAlternativesOn
  };
  const updateBody = target.includes("email" /* EMAIL */) && target.includes("recommendations" /* RECOMMENDATIONS */) ? {
    endpoints: [newLegacyChannel],
    searchCriteria: criterias
  } : target.includes("email" /* EMAIL */) ? {
    endpoints: [newLegacyChannel]
  } : {
    searchCriteria: criterias
  };
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    "/savedsearch/v1/savedsearchmodifications"
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "PUT",
    authenticationToken: token,
    body: { savedSearchId: ssid, ...updateBody }
  });
};
var URL_getWLSavedSearchAnonymous = `${URL_baseRoute}/getFromToken`;
var getWLSavedSearchAnonymous = async (success, error, options) => {
  const { params } = options;
  return baseApiWithResponse(success, error, {
    url: `${URL_getWLSavedSearchAnonymous}?token=${params.token}`,
    httpMethod: "GET"
  });
};
var URL_updateWLChannelAnonymous = `${URL_baseRoute}/channelFromToken`;
var updateWLChannelAnonymous = async (success, error, options) => {
  const { params, value } = options;
  const body = {
    channelName: SavedSearchNotificationChannel.email,
    enabled: value !== "never",
    frequency: value !== "never" ? value : void 0
  };
  return baseApiWithResponse(success, error, {
    url: `${URL_updateWLChannelAnonymous}?token=${params.token}`,
    httpMethod: "PUT",
    body
  });
};
var URL_unsubscribeAllWLChannelAnonymous = `${URL_baseRoute}/unsubscribeAll`;
var unsubscribeAllWLChannelAnonymous = async (success, error, options) => {
  const { params } = options;
  return baseApiWithResponse(success, error, {
    url: `${URL_unsubscribeAllWLChannelAnonymous}?token=${params.token}`,
    httpMethod: "POST",
    body: {}
  });
};
var URL_updateWLAlternativeAnonymous = `${URL_baseRoute}/relaxedCriteriaFromToken`;
var updateWLAlternativeAnonymous = async (success, error, options) => {
  const { params, value } = options;
  const body = {
    enabled: value
  };
  return baseApiWithResponse(success, error, {
    url: `${URL_updateWLAlternativeAnonymous}?token=${params.token}`,
    httpMethod: "PUT",
    body
  });
};

// src/Utils/api/Legacy/index.ts
var getLegacyIWTSavedSearches = async (success, error, options) => {
  const { config, authenticationToken } = options;
  const { stage, brand } = config;
  const endpointUrlLegacy = createLegacyEndpoint(
    stage,
    brand,
    "/savedsearch/v1/savedsearches?includeLookupNotifiedListings=true"
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "GET",
    authenticationToken,
    retryOnFailure: true,
    retryCount: REST_RETRY_COUNT,
    retryDelay: REST_RETRY_TIMEOUT
  });
};
var getLegacySLGSavedSearches = async (success, error, options) => {
  const { config, authenticationToken } = options;
  const { stage, brand } = config;
  const endpointUrlLegacy = createLegacyEndpoint(stage, brand, "/userpreferences-bff/bff/v1/alerts");
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "GET",
    authenticationToken,
    retryOnFailure: true,
    retryCount: REST_RETRY_COUNT,
    retryDelay: REST_RETRY_TIMEOUT
  });
};
var updateLegacyIWTNotificationsState = async (success, error, options) => {
  const { id, item, value, target, config, authenticationToken } = options;
  const emailChannel = item.baseAttributes.endpoints.find((ch) => ch.channelType === "EMAIL_MESSAGE");
  const newLegacyChannel = {
    channelType: "EMAIL_MESSAGE",
    displayName: emailChannel?.displayName ?? "",
    endpointResourceId: emailChannel?.endpointResourceId ?? "",
    notificationFrequency: {
      displayName: value ? "Sofot" : "Nie",
      intervalInMinutes: 0,
      type: value ? "IMMEDIATE" : "NEVER",
      referenceTimestamp: (/* @__PURE__ */ new Date()).toISOString()
    }
  };
  const criterias = {
    ...item?.baseAttributes?.searchCriteria,
    relaxedCriteria: !value ? legacyAlternativesOff : legacyAlternativesOn
  };
  const updateBody = target.includes("email" /* EMAIL */) && target.includes("recommendations" /* RECOMMENDATIONS */) ? {
    endpoints: [newLegacyChannel],
    searchCriteria: criterias
  } : target.includes("email" /* EMAIL */) ? {
    endpoints: [newLegacyChannel]
  } : {
    searchCriteria: criterias
  };
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    "/savedsearch/v1/savedsearchmodifications"
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "PUT",
    authenticationToken,
    body: {
      savedSearchId: id,
      ...updateBody
    }
  });
};
var updateLegacyIWTNotificationsStates = async (success, error, options) => {
  const { id, value, item, target, config, authenticationToken } = options;
  const emailChannel = item.baseAttributes.endpoints.find((ch) => ch.channelType === "EMAIL_MESSAGE");
  const newLegacyChannel = {
    channelType: "EMAIL_MESSAGE",
    displayName: emailChannel?.displayName ?? "",
    endpointResourceId: emailChannel?.endpointResourceId ?? "",
    notificationFrequency: {
      displayName: value.email ? "Sofot" : "Nie",
      intervalInMinutes: 0,
      type: value.email ? "IMMEDIATE" : "NEVER",
      referenceTimestamp: (/* @__PURE__ */ new Date()).toISOString()
    }
  };
  const criterias = {
    ...item?.baseAttributes?.searchCriteria,
    relaxedCriteria: !value.recommendation ? legacyAlternativesOff : legacyAlternativesOn
  };
  const updateBody = target.includes("email" /* EMAIL */) && target.includes("recommendations" /* RECOMMENDATIONS */) ? {
    endpoints: [newLegacyChannel],
    searchCriteria: criterias
  } : target.includes("email" /* EMAIL */) ? {
    endpoints: [newLegacyChannel]
  } : {
    searchCriteria: criterias
  };
  const endpointUrlLegacy = createLegacyEndpoint(
    config.stage,
    config.brand,
    "/savedsearch/v1/savedsearchmodifications"
  );
  return baseApiWithResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "PUT",
    authenticationToken,
    body: {
      savedSearchId: id,
      ...updateBody
    }
  });
};
var updateLegacySLGNotificationsState = async (success, error, options) => {
  const { id, value, config, authenticationToken } = options;
  const { stage, brand } = config;
  const endpointUrlLegacy = createLegacyEndpoint(
    stage,
    brand,
    value ? `/userpreferences-bff/bff/v1/alerts/${id}/subscribe` : `/userpreferences-bff/bff/v1/alerts/${id}/unsubscribe`
  );
  return baseApiWithoutResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "POST",
    authenticationToken
  });
};
var deleteLegacyIWTSavedSearches = async (success, error, options) => {
  const { id, config, authenticationToken } = options;
  const endpointUrlLegacy = createLegacyEndpoint(config.stage, config.brand, `/savedsearch/v1/savedsearches/${id}`);
  return baseApiWithoutResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "DELETE",
    authenticationToken
  });
};
var deleteLegacySLGSavedSearches = async (success, error, options) => {
  const { id, config, authenticationToken } = options;
  const { stage, brand } = config;
  const endpointUrlLegacy = createLegacyEndpoint(stage, brand, `/userpreferences-bff/bff/v1/alerts/${id}`);
  return baseApiWithoutResponse(success, error, {
    url: endpointUrlLegacy,
    httpMethod: "DELETE",
    authenticationToken
  });
};
var clearObject = (toClear) => {
  const cleared = JSON.stringify(toClear, (_, value) => value === null ? void 0 : value);
  return JSON.parse(cleared);
};
var isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
var sortByRencency = (items) => {
  return items.sort((a, b) => {
    return new Date(b.metadata.created).getTime() - new Date(a.metadata.created).getTime();
  });
};
var sortClassifiedsByRecency = (classifieds) => {
  return classifieds.sort((a, b) => {
    return new Date(b.metadata.creationDate).getTime() - new Date(a.metadata.creationDate).getTime();
  });
};
var formatNumber = (input, locale) => {
  let number;
  if (!input) return null;
  if (typeof input === "string") {
    if (isNaN(Number(input))) {
      throw new Error(`${input} is not a number`);
    }
    number = Number(input);
  } else {
    number = input;
  }
  return number.toLocaleString(locale);
};
var getNumberOfLocations = (locations) => {
  return locations.placeIds.length + locations.geometries.circles.length + locations.geometries.polygons.length + locations.geometries.travels.length;
};
var isLegacyIWTSavedSearch = (obj) => {
  return !!obj && "baseAttributes" in obj;
};
var isLegacySLGSavedSearch = (obj) => {
  return !!obj && "searchId" in obj;
};
var createIntermediaryMatchingMandatePayload = (data, search) => {
  return {
    user: {
      name: data.name,
      email: data.email,
      phoneNumber: data.phoneNumber,
      description: data?.message ?? "",
      postalCode: "",
      address: ""
    },
    search: {
      criteria: {
        estateType: search?.estateTypes ?? null,
        distributionType: search?.distributionTypes ?? null,
        prices: {
          priceMin: search?.priceMin ?? null,
          priceMax: search?.priceMax ?? null
        },
        spaces: {
          spaceMin: search?.spaceMin ?? null,
          spaceMax: search?.spaceMax ?? null
        },
        structure: {
          rooms: {
            numberOfRoomsMin: search?.numberOfRoomsMin ?? null,
            numberOfRoomsMax: search?.numberOfRoomsMax ?? null
          }
        },
        location: {
          placeIds: search?.locations?.flatMap(
            (location) => location.type === LocationType.COMMUTE ? location.placeIds : location.type === LocationType.PLACE_ID ? location.placeId : location.type === LocationType.RADIUS ? location.placeId : []
          ) ?? null
        }
      }
    }
  };
};
var getMostRecentSearch = (searches) => {
  if (searches.length === 0) return null;
  const activeSearches = searches.filter(
    (search) => search.channels.find((channel) => channel.channel === SavedSearchNotificationChannel.email)?.enabled
  );
  if (activeSearches.length === 0) return null;
  return activeSearches.reduce((previousSavedSearch, currentSavedSearch) => {
    const previousDate = new Date(previousSavedSearch.metadata.updated).getTime();
    const currentDate = new Date(currentSavedSearch.metadata.updated).getTime();
    return currentDate > previousDate ? currentSavedSearch : previousSavedSearch;
  });
};
var includeCommuteLocation = (locations) => {
  const commutes = locations.filter((location) => location.type === LocationType.COMMUTE);
  return commutes.length > 0;
};
var isIntermediaryMatchingMandateShowable = (brandConfig) => {
  const { intermediaryMatchingMandate, intermediaryMatchingMandateWithLocal } = brandConfig.button;
  if (intermediaryMatchingMandate) return true;
  const hasLocalStorageValue = getLocalStorageItem(intermediaryMatchingMandateLocalStorageKey);
  const hasSessionStorageValue = sessionStorage.getItem(intermediaryMatchingMandateLocalStorageKey);
  if (!hasLocalStorageValue && !hasSessionStorageValue) return false;
  if (intermediaryMatchingMandateWithLocal) return true;
  return false;
};
var useDebugRerender = (options = {}) => {
  const { maxCount = 5, minDelay = 200, maxDelay = 1e3, onRerender } = options;
  const [rerenderCount, setRerenderCount] = useState(0);
  useEffect(() => {
    let timeoutId;
    const scheduleNextUpdate = () => {
      if (rerenderCount < maxCount) {
        console.log("Rerendering...", rerenderCount + 1);
        const randomDelay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;
        timeoutId = setTimeout(() => {
          setRerenderCount((prev) => prev + 1);
          onRerender?.();
          scheduleNextUpdate();
        }, randomDelay);
      }
    };
    scheduleNextUpdate();
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [rerenderCount, maxCount, minDelay, maxDelay, onRerender]);
  return rerenderCount;
};
var useSavedSearch = (stage, brand) => {
  const [savedSearches, setSavedSearches] = useState([]);
  const [lastSavedSearch, setLastSavedSearch] = useState(null);
  const [error, setError] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const { state: authState, authenticate, unsafe_accessToken} = useAuthentication();
  const config = getCustomBrandConfig(brand);
  if (!config) {
    throw new Error("Brand not supported");
  }
  const callConfigs = {
    stage,
    brand,
    basicsKeys: mockedBasicsKeys
  };
  const fetchSavedSearches = async () => {
    setIsFetching(true);
    const options = { authenticationToken: unsafe_accessToken, config: callConfigs };
    const onError = (errorResponse) => {
      setError(errorResponse);
      setIsFetching(false);
    };
    await getSavedSearches(
      (response) => {
        if (response.data.length > 0) {
          const latest = getMostRecentSearch(response.data);
          setLastSavedSearch(latest);
          setSavedSearches(response.data);
        }
      },
      onError,
      options
    );
    setIsFetching(false);
  };
  useEffect(() => {
    (async () => {
      if (authState !== "authenticated" && authState !== "unauthenticated") {
        await authenticate({ shouldRedirect: false });
      }
    })();
  }, [authenticate]);
  return {
    savedSearches,
    lastSavedSearch,
    isFetching,
    authState,
    fetchSavedSearches,
    setSavedSearches,
    unsafe_accessToken,
    error
  };
};
var imnEstateTypeToWLEstateType = /* @__PURE__ */ new Map([
  ["HAUS", EstateType.HOUSE],
  ["WOHNUNG", EstateType.APARTMENT],
  ["GEWERBE_GRUNDSTUECK", EstateType.PLOT],
  ["GRUNDSTUECK", EstateType.PLOT],
  ["BUERO_PRAXISFLAECHE", EstateType.OFFICE],
  ["LADENFLAECHE", EstateType.TRADING],
  ["GASTRONOMIE_HOTEL", EstateType.GASTRONOMY_HOTEL],
  ["HALLEN_INDUSTRIEFLAECHE", EstateType.STORAGE_PRODUCTION],
  ["LAND_FORSTWIRTSCHAFT", EstateType.AGRICULTURE_FORESTRY],
  ["GARAGE_STELLPLATZ", EstateType.PARKING],
  ["SONSTIGES", EstateType.MISCELLANEOUS],
  ["WOHNGEMEINSCHAFT", void 0],
  ["WOHNEN_AUF_ZEIT", void 0],
  ["RENDITEOBJEKT", void 0]
]);
var imnDistributionTypeToWlDistributionType = /* @__PURE__ */ new Map([
  ["ZUM_KAUF", DistributionType.BUY],
  ["ZUR_MIETE", DistributionType.RENT],
  ["ZWANGSVERSTEIGERUNG", DistributionType.COMPULSORY_AUCTION]
]);
var locationInBuildingMap = {
  KEIN_DACHGESCHOSS: [LocationInBuilding.ROOF_STOREY_EXCLUDED],
  KEIN_ERDGESCHOSS: [LocationInBuilding.GROUNDFLOOR_EXCLUDED]
};
var mapEquipmentToLocationInBuilding = (equipment) => {
  let mappedLocationInBuilding = [];
  equipment.forEach((item) => {
    if (locationInBuildingMap[item]) {
      mappedLocationInBuilding = mappedLocationInBuilding.concat(locationInBuildingMap[item]);
    }
  });
  return mappedLocationInBuilding;
};
var LEGACY_MODEL_VERSION = "legacy";
var isLegacySavedSearch = (savedSearch) => savedSearch.metadata.modelVersion === LEGACY_MODEL_VERSION;
var mapLegacyIWTToSavedSearch = (legacySavedSearch) => ({
  criteria: {
    estateType: legacySavedSearch.baseAttributes.searchCriteria.general.estateTypes.map((imnEstateType) => imnEstateTypeToWLEstateType.get(imnEstateType)).filter((x) => x !== void 0),
    distributionType: legacySavedSearch.baseAttributes.searchCriteria.general.distributionTypes.map((imnDstributionType) => imnDistributionTypeToWlDistributionType.get(imnDstributionType)).filter((x) => x !== void 0),
    estateSubType: [],
    distributionSubType: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
      "NUR_NEUBAUPROJEKTE" /* NUR_NEUBAUPROJEKTE */
    ) ? [DistributionSubType.NEW_BUILD_UNIT] : [],
    prices: {
      currencySymbol: "\u20AC",
      currencyUnit: "EUR",
      priceMin: legacySavedSearch.baseAttributes.searchCriteria.pricing.priceMin,
      priceMax: legacySavedSearch.baseAttributes.searchCriteria.pricing.priceMax,
      brokerageFee: { hasFee: HasFee.None }
    },
    spaces: {
      spaceMeasureSymbol: "m\xB2",
      spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
      spaceMin: legacySavedSearch.baseAttributes.searchCriteria.construction.livingAreaMin,
      spaceMax: legacySavedSearch.baseAttributes.searchCriteria.construction.livingAreaMax,
      plotSpaceMin: void 0,
      plotSpaceMax: void 0
    },
    location: {
      placeIds: [],
      geometries: { circles: [], polygons: [], travels: [] },
      placeIdInfos: []
    },
    energy: {
      energyType: {
        energyHeatForm: [],
        energyHeatMethod: [],
        energySource: [],
        energyGeneration: []
      }
    },
    structure: {
      rooms: {
        numberOfRoomsMin: legacySavedSearch.baseAttributes.searchCriteria.construction.roomCountMin ?? void 0,
        numberOfRoomsMax: legacySavedSearch.baseAttributes.searchCriteria.construction.roomCountMax ?? void 0,
        numberOfBalconiesMin: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "BALKON_TERRASSE" /* BALKON_TERRASSE */
        ) ? 1 : void 0,
        numberOfTerracesMin: void 0,
        numberOfBedRoomsMin: void 0,
        numberOfBedRoomsMax: void 0
      },
      building: {
        locationInBuilding: mapEquipmentToLocationInBuilding(
          legacySavedSearch.baseAttributes.searchCriteria.general.equipment
        ),
        bath: {
          window: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
            "BAD_MIT_FENSTER" /* BAD_MIT_FENSTER */
          ) ? true : void 0,
          bathtub: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
            "BAD_MIT_WANNE" /* BAD_MIT_WANNE */
          ) ? true : void 0
        },
        kitchen: {
          equipment: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
            "EINBAUKUECHE" /* EINBAUKUECHE */
          ) ? KitchenEquipment.FULLY_EQUIPPED : KitchenEquipment.UNKNOWN
        },
        withView: {},
        elevator: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "PERSONENAUFZUG" /* PERSONENAUFZUG */
        ) ? [Elevator.ANYKIND] : [],
        cellar: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "TEILWEISE_UNTERKELLERT" /* TEILWEISE_UNTERKELLERT */
        ) || legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "VOLL_UNTERKELLERT" /* VOLL_UNTERKELLERT */
        ) || legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("KELLER" /* KELLER */) ? Cellar.ANYKIND : Cellar.None,
        attic: [BuildingAttic.None]
      },
      parkingLots: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
        "GARAGE_STELLPLATZ" /* GARAGE_STELLPLATZ */
      ) ? { numberOfParkingsMin: 1, numberOfGaragesMin: 1 } : { numberOfParkingsMin: void 0, numberOfGaragesMin: void 0 }
    },
    conditions: {
      yearOfConstructionMin: void 0,
      yearOfConstructionMax: void 0,
      buildState: [BuildState.None],
      energyClass: legacySavedSearch.baseAttributes.searchCriteria.general.energyCertificateClass
    },
    management: {
      isRented: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("FREI" /* FREI */) ? false : void 0,
      isForSwap: void 0,
      rent: {
        petsAllowed: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "HAUSTIERE_ERLAUBT" /* HAUSTIERE_ERLAUBT */
        ) ? true : void 0,
        certificateOfEligibilityNeeded: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
          "WOHNBERECHTIGUNGSSCHEIN" /* WOHNBERECHTIGUNGSSCHEIN */
        ) ? true : void 0
      },
      useFor: [],
      legalNotes: [],
      availableFrom: {}
    },
    features: {
      wheelchairUse: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("BARRIEREFREI" /* BARRIEREFREI */) || legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("ROLLSTUHLGERECHT" /* ROLLSTUHLGERECHT */),
      garden: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("GARTEN" /* GARTEN */) ? [Garden.ANYKIND] : [],
      furnished: legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes("VOLL_MOEBLIERT" /* VOLL_MOEBLIERT */) || legacySavedSearch.baseAttributes.searchCriteria.general.equipment.includes(
        "TEILWEISE_MOEBLIERT" /* TEILWEISE_MOEBLIERT */
      ) ? Furnished.FULL : Furnished.NO,
      propertyOrientation: [],
      residential: {
        swimmingPool: SwimmingPool.None,
        assistedLiving: AssistedLiving.None
      }
    },
    vendor: {
      vendorType: [],
      mandateType: []
    },
    texts: {
      descriptionKeywords: []
    }
  },
  searchMetadata: {
    searchType: SearchType.classified,
    projectType: [],
    deliveryTimeline: DeliveryTimeline.None
  },
  title: legacySavedSearch.baseAttributes.config.searchDisplayName,
  identity: {
    id: legacySavedSearch.baseAttributes.id,
    userId: legacySavedSearch.baseAttributes.userId + "",
    portal: legacySavedSearch.baseAttributes.origin
  },
  state: SavedSearchState.enabled,
  metadata: {
    modelVersion: LEGACY_MODEL_VERSION,
    created: "",
    updated: "",
    origin: SavedSearchOrigin.SavedSearch
  },
  channels: legacySavedSearch.baseAttributes.endpoints.map((legacyEndpoint) => ({
    channel: legacyEndpoint.channelType === "EMAIL_MESSAGE" ? SavedSearchNotificationChannel.email : SavedSearchNotificationChannel.mobile,
    enabled: legacyEndpoint.channelType === "EMAIL_MESSAGE" && legacyEndpoint.notificationFrequency.type !== "NEVER",
    email: legacyEndpoint.channelType === "EMAIL_MESSAGE" ? legacyEndpoint.endpointResourceId : ""
  })),
  externalProperties: {
    channelId: "",
    deviceType: SavedSearchDeviceType.None
  },
  relaxedCriteria: {
    isEnabled: legacySavedSearch?.baseAttributes?.searchCriteria?.relaxedCriteria?.relaxEquipmentMode === "IGNORE_SINGLE" /* SINGLE */,
    options: {
      locationSearchAreaIncrease: legacySavedSearch?.baseAttributes?.searchCriteria?.relaxedCriteria?.location ?? 0,
      priceIncreaseInPercent: legacySavedSearch?.baseAttributes?.searchCriteria?.relaxedCriteria?.primaryPriceMax ?? 0,
      surfaceDecreaseInPercent: legacySavedSearch?.baseAttributes?.searchCriteria?.relaxedCriteria?.primaryAreaMin ?? 0,
      relaxedCriteriaRemoval: false
    }
  }
});
var mapLegacySLGDataToSavedSearch = (legacySavedSearch) => ({
  title: legacySavedSearch.title,
  externalProperties: {
    channelId: "",
    deviceType: SavedSearchDeviceType.None
  },
  state: SavedSearchState.enabled,
  metadata: {
    modelVersion: LEGACY_MODEL_VERSION,
    created: "",
    updated: "",
    origin: SavedSearchOrigin.SavedSearch
  },
  relaxedCriteria: {
    isEnabled: false,
    options: {}
  },
  identity: {
    id: legacySavedSearch.searchId.toString(),
    userId: "1",
    portal: "sl"
  },
  channels: [
    {
      channel: SavedSearchNotificationChannel.email,
      enabled: legacySavedSearch.isActive
    }
  ],
  criteria: {
    estateType: legacySavedSearch.searchCriterias.includes("Appartement") ? [EstateType.APARTMENT] : [EstateType.HOUSE],
    distributionType: legacySavedSearch.searchCriterias.includes("Vente") ? [DistributionType.BUY] : [DistributionType.RENT],
    estateSubType: [],
    distributionSubType: [],
    prices: {
      currencySymbol: "\u20AC",
      currencyUnit: "EUR",
      priceMin: void 0,
      priceMax: void 0,
      brokerageFee: { hasFee: HasFee.None }
    },
    spaces: {
      spaceMeasureSymbol: "m\xB2",
      spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
      spaceMin: void 0,
      spaceMax: void 0,
      plotSpaceMin: void 0,
      plotSpaceMax: void 0
    },
    location: {
      placeIds: [],
      geometries: { circles: [], polygons: [], travels: [] },
      placeIdInfos: []
    },
    structure: {
      rooms: {
        numberOfRoomsMin: void 0,
        numberOfRoomsMax: void 0,
        numberOfBalconiesMin: void 0,
        numberOfTerracesMin: void 0,
        numberOfBedRoomsMin: void 0,
        numberOfBedRoomsMax: void 0
      },
      building: {
        locationInBuilding: [],
        bath: {
          window: void 0,
          bathtub: void 0
        },
        kitchen: {
          equipment: KitchenEquipment.UNKNOWN
        },
        withView: {},
        elevator: [],
        cellar: Cellar.None,
        attic: []
      },
      parkingLots: { numberOfParkingsMin: void 0, numberOfGaragesMin: void 0 }
    },
    conditions: {
      yearOfConstructionMax: void 0,
      yearOfConstructionMin: void 0,
      buildState: [],
      energyClass: []
    },
    energy: {
      energyType: {
        energyHeatForm: [],
        energyHeatMethod: [],
        energySource: [],
        energyGeneration: []
      }
    },
    management: {
      isRented: void 0,
      isForSwap: void 0,
      rent: {
        petsAllowed: void 0,
        certificateOfEligibilityNeeded: void 0
      },
      useFor: [],
      legalNotes: [],
      availableFrom: {}
    },
    features: {
      wheelchairUse: void 0,
      garden: [],
      furnished: Furnished.None,
      residential: {
        swimmingPool: SwimmingPool.None,
        assistedLiving: AssistedLiving.None
      },
      propertyOrientation: []
    },
    vendor: {
      vendorType: [],
      mandateType: []
    },
    texts: {
      descriptionKeywords: []
    }
  },
  searchMetadata: {
    searchType: SearchType.classified,
    projectType: [],
    deliveryTimeline: DeliveryTimeline.None
  }
});
var getCriteriaBuildState = (searchModel) => {
  return searchModel.buildState?.map((v) => BuildState[v.toUpperCase()]).filter((v) => v !== void 0) ?? [];
};
var getSearchBuildState = (criterias) => {
  const result = criterias?.conditions?.buildState?.map((v) => BuildState$1[v.toUpperCase()]).filter((v) => v !== void 0) ?? [];
  return result.length ? result : void 0;
};
var getCriteriaCertificateOfEligibilityNeeded = (searchModel) => {
  switch (searchModel.certificateOfEligibilityNeeded) {
    case CertificateOfEligibility.YES:
      return true;
    case CertificateOfEligibility.NO:
      return false;
  }
  return void 0;
};
var getSearchCertificateOfEligibilityNeeded = (criterias) => {
  switch (criterias?.management?.rent?.certificateOfEligibilityNeeded) {
    case true:
      return CertificateOfEligibility.YES;
    case false:
      return CertificateOfEligibility.NO;
  }
  return void 0;
};
var getCriteriaVendorType = (searchModel) => {
  return searchModel.classifiedBusiness == ProviderType.PRIVATE ? [VendorType.PRIVATE] : searchModel.classifiedBusiness == ProviderType.PROFESSIONAL ? [VendorType.PROFESSIONAL, VendorType.PROFESSIONAL_UNITARY] : [];
};
var getSearchClassifiedBusiness = (criterias) => {
  const vendorType = criterias?.vendor?.vendorType ?? [];
  return vendorType.includes(VendorType.PRIVATE) ? ProviderType.PRIVATE : vendorType.includes(VendorType.PROFESSIONAL) || vendorType.includes(VendorType.PROFESSIONAL_UNITARY) ? ProviderType.PROFESSIONAL : void 0;
};
var searchToCriteriaMap = /* @__PURE__ */ new Map([
  [DistributionType$1.BUY, DistributionType.BUY],
  [DistributionType$1.BUY_AUCTION, DistributionType.BUY_AUCTION],
  [DistributionType$1.COMPULSORY_AUCTION, DistributionType.COMPULSORY_AUCTION],
  [DistributionType$1.RENT, DistributionType.RENT]
]);
var getCriteriaDistributionType = (searchModel) => {
  const result = /* @__PURE__ */ new Set();
  for (const v of searchModel?.distributionTypes ?? []) {
    const distributionType = searchToCriteriaMap.get(v);
    if (distributionType !== void 0) {
      result.add(distributionType);
    }
  }
  return Array.from(result);
};
var criteriaToSearchMap = /* @__PURE__ */ new Map([
  [DistributionType.BUY, DistributionType$1.BUY],
  [DistributionType.BUY_AUCTION, DistributionType$1.BUY_AUCTION],
  [DistributionType.COMPULSORY_AUCTION, DistributionType$1.COMPULSORY_AUCTION],
  [DistributionType.RENT, DistributionType$1.RENT]
]);
var getSearchDistributionType = (criterias) => {
  const result = /* @__PURE__ */ new Set();
  for (const v of criterias?.distributionType ?? []) {
    const distributionType = criteriaToSearchMap.get(v);
    if (distributionType !== void 0) {
      result.add(distributionType);
    }
  }
  return Array.from(result);
};
var getCriteriaEnergyCertificateClass = (searchModel) => {
  const result = /* @__PURE__ */ new Set();
  for (const v of searchModel.energyCertificateClass ?? []) {
    const energyClass = EnergyClass[v.toUpperCase()];
    if (energyClass !== void 0 && energyClass !== EnergyClass.None) {
      result.add(energyClass);
    }
  }
  return Array.from(result);
};
var getSearchEnergyCertificateClass = (criterias) => {
  const result = criterias?.conditions?.energyClass ?? [];
  return result.length ? result : void 0;
};

// src/Utils/mapping/criterias/utils.ts
function remapFromMap(toRemap, map) {
  const set = new Set(toRemap.filter((energy) => map.has(energy)).map((energy) => map.get(energy)));
  return [...set].filter((type) => type !== void 0);
}

// src/Utils/mapping/criterias/energyTypes.ts
var mapSearchEnergyTypeToEnergyGeneration = /* @__PURE__ */ new Map([
  [EnergyType.HEAT_PUMP, EnergyGeneration.HEAT_PUMP]
]);
var mapSearchEnergyTypeToEnergyHeatForm = /* @__PURE__ */ new Map([
  [EnergyType.UNDERFLOOR, EnergyHeatForm.UNDERFLOOR]
]);
var mapSearchEnergyTypeToEnergyHeatMethod = /* @__PURE__ */ new Map([
  [EnergyType.CENTRAL, EnergyHeatMethod.CENTRAL],
  [EnergyType.STOREY, EnergyHeatMethod.STOREY]
]);
var mapSearchEnergyTypeToEnergySource = /* @__PURE__ */ new Map([
  [EnergyType.PHOTOVOLTAIC_PANELS, EnergySource.HASPHOTOVOLTAICPANELS],
  [EnergyType.SOLAR_HEAT, EnergySource.SOLARHEAT],
  [EnergyType.SOLAR_POWER, EnergySource.SOLARPOWER],
  [EnergyType.THERMIC_PANELS, EnergySource.HASTHERMICPANELS]
]);
var getCriteriaEnergyTypes = (searchModel) => {
  const energyTypes = searchModel.energyTypes ?? [];
  return {
    energyGeneration: remapFromMap(energyTypes, mapSearchEnergyTypeToEnergyGeneration),
    energyHeatForm: remapFromMap(energyTypes, mapSearchEnergyTypeToEnergyHeatForm),
    energyHeatMethod: remapFromMap(energyTypes, mapSearchEnergyTypeToEnergyHeatMethod),
    energySource: remapFromMap(energyTypes, mapSearchEnergyTypeToEnergySource)
  };
};
var mapSavedSearchEnergyTypesToSearchEnergyType = /* @__PURE__ */ new Map([
  [EnergyGeneration.HEAT_PUMP, EnergyType.HEAT_PUMP],
  [EnergyHeatForm.UNDERFLOOR, EnergyType.UNDERFLOOR],
  [EnergyHeatMethod.CENTRAL, EnergyType.CENTRAL],
  [EnergyHeatMethod.STOREY, EnergyType.STOREY],
  [EnergySource.HASPHOTOVOLTAICPANELS, EnergyType.PHOTOVOLTAIC_PANELS],
  [EnergySource.SOLARHEAT, EnergyType.SOLAR_HEAT],
  [EnergySource.SOLARPOWER, EnergyType.SOLAR_POWER],
  [EnergySource.HASTHERMICPANELS, EnergyType.THERMIC_PANELS]
]);
var getSearchEnergyTypes = (criterias) => {
  const energyTypes = remapFromMap(
    [
      ...criterias.energy?.energyType?.energyHeatForm ?? [],
      ...criterias.energy?.energyType?.energyHeatMethod ?? [],
      ...criterias.energy?.energyType?.energySource ?? [],
      ...criterias.energy?.energyType?.energyGeneration ?? []
    ],
    mapSavedSearchEnergyTypesToSearchEnergyType
  );
  return energyTypes.length ? energyTypes : void 0;
};
var getCriteriaEstateSubType = (searchModel) => {
  const result = /* @__PURE__ */ new Set();
  for (const v of searchModel.estateSubTypes ?? []) {
    const estateSubType = EstateSubType[v.toUpperCase()];
    if (estateSubType !== void 0 && estateSubType !== EstateSubType.None) {
      result.add(estateSubType);
    }
  }
  return Array.from(result);
};
var getSearchEstateSubType = (criterias) => {
  const result = /* @__PURE__ */ new Set();
  for (const v of criterias?.estateSubType ?? []) {
    const estateSubType = EstateSubType$1[v];
    if (estateSubType !== void 0) {
      result.add(estateSubType);
    }
  }
  return result.size ? Array.from(result) : void 0;
};
var criteriaEstateTypeMap = /* @__PURE__ */ new Map([
  [EstateType$1.HOUSE, EstateType.HOUSE],
  [EstateType$1.APARTMENT, EstateType.APARTMENT],
  [EstateType$1.SENIOR, EstateType.SENIOR],
  [EstateType$1.PARKING, EstateType.PARKING],
  [EstateType$1.PLOT, EstateType.PLOT],
  [EstateType$1.MISCELLANEOUS, EstateType.MISCELLANEOUS],
  [EstateType$1.OFFICE, EstateType.OFFICE],
  [EstateType$1.TRADING, EstateType.TRADING],
  [EstateType$1.GASTRONOMY_HOTEL, EstateType.GASTRONOMY_HOTEL],
  [EstateType$1.STORAGE_PRODUCTION, EstateType.STORAGE_PRODUCTION],
  [EstateType$1.AGRICULTURE_FORESTRY, EstateType.AGRICULTURE_FORESTRY],
  [EstateType$1.BUILDING, EstateType.BUILDING]
]);
var getCriteriaEstateType = (searchModel) => {
  const result = /* @__PURE__ */ new Set();
  for (const estateType of searchModel.estateTypes ?? []) {
    const mappedEstateType = criteriaEstateTypeMap.get(estateType);
    if (mappedEstateType) {
      result.add(mappedEstateType);
    }
  }
  if (searchModel.projectTypes?.includes(ProjectType.PROJECTED) || searchModel.estateTypes?.includes(EstateType$1.HOUSE) || searchModel.estateTypes?.includes(EstateType$1.APARTMENT)) {
    result.add(EstateType.PROJECT);
  }
  return Array.from(result);
};
var SearchEstateTypeMap = /* @__PURE__ */ new Map([
  // [EstateType.None, undefined],
  [EstateType.HOUSE, EstateType$1.HOUSE],
  [EstateType.APARTMENT, EstateType$1.APARTMENT],
  [EstateType.SENIOR, EstateType$1.SENIOR],
  [EstateType.PARKING, EstateType$1.PARKING],
  [EstateType.PLOT, EstateType$1.PLOT],
  [EstateType.MISCELLANEOUS, EstateType$1.MISCELLANEOUS],
  [EstateType.OFFICE, EstateType$1.OFFICE],
  [EstateType.TRADING, EstateType$1.TRADING],
  [EstateType.GASTRONOMY_HOTEL, EstateType$1.GASTRONOMY_HOTEL],
  [EstateType.STORAGE_PRODUCTION, EstateType$1.STORAGE_PRODUCTION],
  [EstateType.AGRICULTURE_FORESTRY, EstateType$1.AGRICULTURE_FORESTRY],
  [EstateType.BUILDING, EstateType$1.BUILDING]
  // [EstateType.PROJECT, undefined],
]);
var getSearchEstateType = (criterias) => {
  return remapFromMap(criterias?.estateType ?? [], SearchEstateTypeMap);
};
var getCriteriaBrokerageFee = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.COMMISSION_FREE) ? { hasFee: HasFee.NO } : { hasFee: HasFee.None };
};
var getCriteriaBathroom = (searchModel) => {
  return {
    window: searchModel.featuresIncluded?.includes(FeatureType.BATHROOM_WINDOW) ? true : void 0,
    bathtub: searchModel.featuresIncluded?.includes(FeatureType.BATHROOM_BATHTUB) ? true : void 0
  };
};
var getCriteriaKitchen = (searchModel) => {
  return {
    equipment: searchModel.featuresIncluded?.includes(FeatureType.KITCHEN_FULLY_EQUIPPED) ? KitchenEquipment.FULLY_EQUIPPED : KitchenEquipment.UNKNOWN
  };
};
var getCriteriaElevator = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.ELEVATOR) ? [Elevator.ANYKIND] : [];
};
var getCriteriaCellar = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.CELLAR) ? Cellar.ANYKIND : Cellar.None;
};
var getCriteriaParkingLots = (searchModel) => {
  return {
    numberOfParkingsMin: searchModel.featuresIncluded?.includes(FeatureType.PARKING_GARAGE) ? 1 : void 0,
    numberOfGaragesMin: void 0
  };
};
var getCriteriaIsRented = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.VACANT) ? false : void 0;
};
var getCriteriaPetAllowed = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.PETS_ALLOWED) ? true : void 0;
};
var getCriteriaWheelchairUse = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.REDUCE_MOBILITY_ACCESS) ? true : void 0;
};
var getCriteriaGarden = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.GARDEN) ? [Garden.ANYKIND] : [];
};
var getCriteriaSwimmingPool = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.SWIMMING_POOL) ? SwimmingPool.ANYKIND : SwimmingPool.None;
};
var getCriteriaAssistedLiving = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.ASSISTED_LIVING) ? AssistedLiving.YES : AssistedLiving.None;
};
var getCriteriaMandateType = (searchModel) => {
  return searchModel.featuresIncluded?.includes(FeatureType.EXCLUSIVE_MANDATE) ? [MandateType.EXCLUSIVE] : [];
};
var getSearchFeaturesIncluded = (criterias) => {
  const features = [];
  if (criterias?.prices?.brokerageFee?.hasFee === HasFee.NO) {
    features.push(FeatureType.COMMISSION_FREE);
  }
  if (criterias?.structure?.rooms?.numberOfBalconiesMin) {
    features.push(FeatureType.BALCONY_TERRACE);
  }
  if (criterias?.structure?.building?.bath?.window) {
    features.push(FeatureType.BATHROOM_WINDOW);
  }
  if (criterias?.structure?.building?.bath?.bathtub) {
    features.push(FeatureType.BATHROOM_BATHTUB);
  }
  if (criterias?.structure?.building?.kitchen?.equipment === KitchenEquipment.FULLY_EQUIPPED) {
    features.push(FeatureType.KITCHEN_FULLY_EQUIPPED);
  }
  if (criterias?.structure?.building?.elevator?.length) {
    features.push(FeatureType.ELEVATOR);
  }
  if (criterias?.structure?.building?.cellar === Cellar.ANYKIND) {
    features.push(FeatureType.CELLAR);
  }
  if (criterias?.structure?.parkingLots?.numberOfParkingsMin || criterias?.structure?.parkingLots?.numberOfGaragesMin) {
    features.push(FeatureType.PARKING_GARAGE);
  }
  if (criterias?.management?.rent?.petsAllowed) {
    features.push(FeatureType.PETS_ALLOWED);
  }
  if (criterias?.management?.isRented === false) {
    features.push(FeatureType.VACANT);
  }
  if (criterias?.features?.wheelchairUse) {
    features.push(FeatureType.REDUCE_MOBILITY_ACCESS);
  }
  if (criterias?.features?.garden?.length) {
    features.push(FeatureType.GARDEN);
  }
  if (criterias?.features?.residential?.swimmingPool === SwimmingPool.ANYKIND) {
    features.push(FeatureType.SWIMMING_POOL);
  }
  if (criterias?.features?.residential?.assistedLiving === AssistedLiving.YES) {
    features.push(FeatureType.ASSISTED_LIVING);
  }
  if (criterias?.vendor?.mandateType?.includes(MandateType.EXCLUSIVE)) {
    features.push(FeatureType.EXCLUSIVE_MANDATE);
  }
  return features.length ? features : void 0;
};
var getCriteriaFurnished = (searchModel) => {
  const furnished = searchModel.furnished;
  if (!furnished) {
    return Furnished.None;
  }
  if (furnished.includes(Furnished$1.FULL) && furnished.includes(Furnished$1.NO)) {
    return Furnished.ANYKIND;
  }
  if (furnished.includes(Furnished$1.FULL)) {
    return Furnished.FULL;
  }
  if (furnished.includes(Furnished$1.NO)) {
    return Furnished.NO;
  }
  if (furnished.includes(Furnished$1.NOT_APPLICABLE)) {
    return Furnished.NOT_APPLICABLE;
  }
  return Furnished.None;
};
var getSearchFurnished = (criterias) => {
  switch (criterias?.features?.furnished) {
    case Furnished.FULL:
      return [Furnished$1.FULL];
    case Furnished.NO:
      return [Furnished$1.NO];
    case Furnished.NOT_APPLICABLE:
      return [Furnished$1.NOT_APPLICABLE];
    case Furnished.ANYKIND:
      return [Furnished$1.FULL, Furnished$1.NO];
    default:
      return void 0;
  }
};
var searchBusinessEstateTypes = /* @__PURE__ */ new Set([
  EstateType$1.GASTRONOMY_HOTEL,
  EstateType$1.TRADING
]);
var getCriteriaDistributionSubTypeWithIsSaleGoodwillAdaptation = (searchModel, criteria) => {
  const result = new Set(criteria);
  if (searchModel.estateTypes?.some((estateType) => searchBusinessEstateTypes.has(estateType)) !== true) {
    return result;
  }
  if (searchModel.distributionTypes?.includes(DistributionType$1.BUY)) {
    if (searchModel.isSaleGoodwill === true) {
      result.clear();
      result.add(DistributionSubType.BUSINESS_SALE_GOODWILL);
    } else if (searchModel.isSaleGoodwill === false) {
      result.delete(DistributionSubType.BUSINESS_SALE_GOODWILL);
      if (result.size === 0) {
        result.add(DistributionSubType.RESALE);
      }
    }
  }
  if (searchModel.distributionTypes?.includes(DistributionType$1.RENT)) {
    if (result.size > 1) {
      result.add(DistributionSubType.BUSINESS_LEASEBACK);
    }
  }
  return result;
};
var businessEstateTypes = /* @__PURE__ */ new Set([EstateType.GASTRONOMY_HOTEL, EstateType.TRADING]);
var getSearchIsSaleGoodwill = (criterias) => {
  if (criterias.estateType?.some((estateType) => businessEstateTypes.has(estateType)) !== true) {
    return void 0;
  }
  if (criterias.distributionType?.includes(DistributionType.BUY)) {
    if (criterias.distributionSubType?.length === 1 && criterias.distributionSubType[0] === DistributionSubType.BUSINESS_SALE_GOODWILL) {
      return true;
    }
    if ((criterias.distributionSubType?.length ?? 0) > 0 && criterias.distributionSubType?.includes(DistributionSubType.BUSINESS_SALE_GOODWILL) === false) {
      return false;
    }
  }
  return void 0;
};
var getSearchProjectTypeWithIsSaleGoodwillAdaptation = (criterias, searchCriteria) => {
  const result = new Set(searchCriteria);
  if (getSearchIsSaleGoodwill(criterias) === false && result.has(ProjectType.RESALE) && result.size === 1) {
    result.delete(ProjectType.RESALE);
  }
  return result;
};

// src/Utils/helpers/polyline.ts
function py2Round(value) {
  return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
}
function encodeValue(current, previous, factor) {
  let currentRounded = py2Round(current * factor);
  let previousRounded = py2Round(previous * factor);
  let coordinate = (currentRounded - previousRounded) * 2;
  if (coordinate < 0) {
    coordinate = -coordinate - 1;
  }
  let output = "";
  while (coordinate >= 32) {
    output += String.fromCharCode((32 | coordinate & 31) + 63);
    coordinate = Math.floor(coordinate / 32);
  }
  output += String.fromCharCode((coordinate | 0) + 63);
  return output;
}
function encodePolyline(coordinates, precision) {
  if (!coordinates.length) {
    return "";
  }
  const factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
  let output = encodeValue(coordinates[0][0], 0, factor) + encodeValue(coordinates[0][1], 0, factor);
  for (let i = 1; i < coordinates.length; i++) {
    const a = coordinates[i];
    const b = coordinates[i - 1];
    output += encodeValue(a[0], b[0], factor);
    output += encodeValue(a[1], b[1], factor);
  }
  return output;
}
function isRadiusLocation(obj) {
  return obj.type === LocationType.RADIUS;
}
function isSearchCommuteLocation(obj) {
  return obj.type === LocationType.COMMUTE;
}
function isDrawingLocation(obj) {
  return obj.type === LocationType.DRAWING;
}
function isBaseLocation(obj) {
  return obj.type === LocationType.PLACE_ID;
}
var getCriteriaLocation = (searchModel) => {
  const result = {
    placeIds: [],
    geometries: { circles: [], polygons: [], travels: [] },
    placeIdInfos: []
  };
  const locations = searchModel.locations;
  if (!locations?.length) {
    return result;
  }
  const radiusLocations = locations.filter(isRadiusLocation);
  const commuteLocations = locations.filter(isSearchCommuteLocation);
  const drawingLocations = locations.filter(isDrawingLocation);
  result.geometries.circles = radiusLocations.map((el) => ({
    radius: el.radius,
    radiusUnit: LocationGeometryCircleRadiusUnit.km,
    centerPlaceId: el.placeId,
    locationGeometryCoordinate: { latitude: el.coordinates?.lat ?? 0, longitude: el.coordinates?.lng ?? 0 }
  }));
  result.geometries.travels = commuteLocations.map((commute) => ({
    placeIds: commute.placeIds,
    travelMode: [searchCommuteToSavedSearchTravelMode[commute.mode]],
    travelUnit: LocationGeometryTravelUnit.MINUTE,
    travelValue: commute.duration
  }));
  result.geometries.polygons = drawingLocations.flatMap(
    (drawing) => drawing.drawings.map((draw) => ({
      polyline: draw
    }))
  );
  result.placeIds = locations.filter(isBaseLocation).map((l) => l.placeId).filter((id) => id != null);
  return result;
};
var searchCommuteToSavedSearchTravelMode = {
  [CommuteMode.BIKE]: LocationGeometryTravelMode.BIKE,
  [CommuteMode.CAR]: LocationGeometryTravelMode.CAR,
  [CommuteMode.TRANSIT]: LocationGeometryTravelMode.TRANSIT,
  [CommuteMode.WALK]: LocationGeometryTravelMode.WALK
};
var getSearchLocation = (criterias) => {
  const locations = criterias?.location;
  if (!locations) {
    return [];
  }
  const result = [];
  if (locations.placeIds.length) {
    result.push(
      ...locations.placeIds.map((placeId) => ({ type: LocationType.PLACE_ID, placeId }))
    );
  }
  if (locations.geometries.polygons.length) {
    result.push(
      ...locations.geometries.polygons.map((polygon) => ({
        type: LocationType.DRAWING,
        drawings: [polygon.polyline]
      }))
    );
  }
  if (locations.geometries.circles.length) {
    result.push(...locations.geometries.circles.map(getSearchRadiusLocation).filter((x) => x !== void 0));
  }
  if (locations.geometries.travels.length) {
    result.push(
      ...locations.geometries.travels.filter((travel) => travel.travelUnit === LocationGeometryTravelUnit.MINUTE).flatMap(
        (commute) => commute.travelMode.map((mode) => ({
          type: LocationType.COMMUTE,
          duration: commute.travelValue,
          mode: savedSearchTravelModeToSearchCommute[mode],
          placeIds: commute.placeIds,
          polylines: []
        }))
      )
    );
  }
  return result;
};
var savedSearchTravelModeToSearchCommute = {
  [LocationGeometryTravelMode.BIKE]: CommuteMode.BIKE,
  [LocationGeometryTravelMode.CAR]: CommuteMode.CAR,
  [LocationGeometryTravelMode.TRANSIT]: CommuteMode.TRANSIT,
  [LocationGeometryTravelMode.WALK]: CommuteMode.WALK
};
var getSearchRadiusLocation = ({
  radius,
  centerPlaceId,
  locationGeometryCoordinate: { latitude, longitude },
  radiusUnit
}) => {
  try {
    const radiusInMeter = radiusUnit === LocationGeometryCircleRadiusUnit.km ? radius * 1e3 : radius;
    const {
      coordinates: [firstCoordinate]
    } = circleToPolygon([longitude, latitude], radiusInMeter, 32);
    if (!firstCoordinate || firstCoordinate.length === 0) {
      return void 0;
    }
    const polyline = encodePolyline(firstCoordinate.map(([longitude2, latitude2]) => [latitude2, longitude2]));
    return {
      type: LocationType.RADIUS,
      placeId: centerPlaceId,
      radius,
      polyline,
      coordinates: {
        lat: latitude,
        lng: longitude
      }
    };
  } catch {
    return void 0;
  }
};
var getCriteriaLocationInBuilding = (searchModel) => {
  const result = /* @__PURE__ */ new Set();
  for (const locationInBuilding of searchModel.locationsInBuildingIncluded ?? []) {
    switch (locationInBuilding) {
      case LocationInBuildingType.GROUND_FLOOR:
        result.add(LocationInBuilding.GROUNDFLOOR);
        break;
      case LocationInBuildingType.ROOF_STOREY:
        result.add(LocationInBuilding.ROOF_STOREY);
        break;
    }
  }
  for (const locationInBuilding of searchModel.locationsInBuildingExcluded ?? []) {
    switch (locationInBuilding) {
      case LocationInBuildingType.GROUND_FLOOR:
        result.add(LocationInBuilding.GROUNDFLOOR_EXCLUDED);
        break;
      case LocationInBuildingType.ROOF_STOREY:
        result.add(LocationInBuilding.ROOF_STOREY_EXCLUDED);
        break;
    }
  }
  return Array.from(result);
};
var getSearchLocationsInBuilding = (criterias) => {
  const excluded = /* @__PURE__ */ new Set();
  const included = /* @__PURE__ */ new Set();
  for (const element of criterias?.structure?.building?.locationInBuilding ?? []) {
    switch (element) {
      case LocationInBuilding.GROUNDFLOOR:
        included.add(LocationInBuildingType.GROUND_FLOOR);
        break;
      case LocationInBuilding.ROOF_STOREY:
        included.add(LocationInBuildingType.ROOF_STOREY);
        break;
      case LocationInBuilding.GROUNDFLOOR_EXCLUDED:
        excluded.add(LocationInBuildingType.GROUND_FLOOR);
        break;
      case LocationInBuilding.ROOF_STOREY_EXCLUDED:
        excluded.add(LocationInBuildingType.ROOF_STOREY);
        break;
    }
  }
  return {
    exclude: excluded.size ? Array.from(excluded) : void 0,
    include: included.size ? Array.from(included) : void 0
  };
};
var mapSearchProjectTypeToProjectType = /* @__PURE__ */ new Map([
  [ProjectType.FLATSHARING, ProjectType$1.FLATSHARING],
  [ProjectType.INVESTMENT, ProjectType$1.INVESTMENT],
  [ProjectType.NEW_BUILD, ProjectType$1.NEW_BUILD],
  [ProjectType.PROJECTED, ProjectType$1.PROJECTED],
  [ProjectType.RESALE, ProjectType$1.RESALE],
  [ProjectType.SHORT_TIME_RENTAL, ProjectType$1.SHORT_TIME_RENTAL],
  [ProjectType.STOCK, ProjectType$1.STOCK],
  [ProjectType.SWAP_APARTMENT, ProjectType$1.SWAP_APARTMENT],
  [ProjectType.LIFE_ANNUITY, ProjectType$1.LIFE_ANNUITY]
]);
var getMetadataProjectType = (searchModel) => {
  return remapFromMap(searchModel.projectTypes ?? [], mapSearchProjectTypeToProjectType);
};
var getCriteriaDistributionSubType = (searchModel) => {
  let result = /* @__PURE__ */ new Set();
  for (const projectType of searchModel.projectTypes ?? []) {
    switch (projectType) {
      case ProjectType.INVESTMENT:
        result.add(DistributionSubType.NEW_BUILD_INVESTMENT_PRODUCT);
        break;
      case ProjectType.NEW_BUILD:
        result.add(DistributionSubType.NEW_BUILD_UNIT);
        break;
      case ProjectType.PROJECTED:
        result.add(DistributionSubType.NEW_HOME);
        break;
      case ProjectType.LIFE_ANNUITY:
        result.add(DistributionSubType.LIFE_ANNUITY);
        break;
      case ProjectType.SHORT_TIME_RENTAL:
        result.add(DistributionSubType.TEMPORARY);
        result.add(DistributionSubType.VACATION);
        break;
      case ProjectType.STOCK:
        result.add(DistributionSubType.CLASSIC);
        result.add(DistributionSubType.BUSINESS);
        break;
      case ProjectType.RESALE:
        result.add(DistributionSubType.RESALE);
        break;
    }
  }
  result = getCriteriaDistributionSubTypeWithIsSaleGoodwillAdaptation(searchModel, result);
  return Array.from(result);
};
var getCriteriaIsForSwap = (searchModel) => {
  if (searchModel.distributionTypes?.includes(DistributionType$1.RENT) !== true) {
    return void 0;
  }
  if (searchModel.estateTypes?.includes(EstateType$1.APARTMENT) !== true && searchModel.estateTypes?.includes(EstateType$1.HOUSE) !== true) {
    return void 0;
  }
  const projectType = searchModel.projectTypes ?? [];
  if (projectType.includes(ProjectType.SWAP_APARTMENT) && projectType.length === 1) {
    return true;
  }
  if (!projectType.includes(ProjectType.SWAP_APARTMENT) && projectType.length > 0) {
    return false;
  }
  return void 0;
};
var getCriteriaIsForFlatsharing = (searchModel) => {
  if (searchModel.distributionTypes?.includes(DistributionType$1.RENT) !== true) {
    return void 0;
  }
  if (searchModel.estateTypes?.includes(EstateType$1.APARTMENT) !== true && searchModel.estateTypes?.includes(EstateType$1.HOUSE) !== true) {
    return void 0;
  }
  const projectTypes = searchModel.projectTypes ?? [];
  if (projectTypes.includes(ProjectType.FLATSHARING) && projectTypes.length === 1) {
    return true;
  }
  if (!projectTypes.includes(ProjectType.FLATSHARING) && projectTypes.length > 0) {
    return false;
  }
  return void 0;
};
var mapProjectTypeToSearchProjectType = /* @__PURE__ */ new Map([
  [ProjectType$1.FLATSHARING, ProjectType.FLATSHARING],
  [ProjectType$1.INVESTMENT, ProjectType.INVESTMENT],
  [ProjectType$1.NEW_BUILD, ProjectType.NEW_BUILD],
  [ProjectType$1.PROJECTED, ProjectType.PROJECTED],
  [ProjectType$1.RESALE, ProjectType.RESALE],
  [ProjectType$1.SHORT_TIME_RENTAL, ProjectType.SHORT_TIME_RENTAL],
  [ProjectType$1.STOCK, ProjectType.STOCK],
  [ProjectType$1.SWAP_APARTMENT, ProjectType.SWAP_APARTMENT],
  [ProjectType$1.LIFE_ANNUITY, ProjectType.LIFE_ANNUITY]
]);
var getSearchProjectType = (savedSearch) => {
  if (savedSearch.searchMetadata.projectType?.length) {
    const projecTypes = remapFromMap(savedSearch.searchMetadata.projectType, mapProjectTypeToSearchProjectType);
    return projecTypes.length ? projecTypes : void 0;
  } else {
    return getComputedSearchProjectType(savedSearch.criteria);
  }
};
var getComputedSearchProjectType = (criterias) => {
  let result = /* @__PURE__ */ new Set();
  const distributionSubTypes = criterias.distributionSubType ?? [];
  for (const distributionSubType of distributionSubTypes) {
    switch (distributionSubType) {
      case DistributionSubType.RESALE:
        result.add(ProjectType.RESALE);
        break;
      case DistributionSubType.LIFE_ANNUITY:
        result.add(ProjectType.LIFE_ANNUITY);
        break;
      case DistributionSubType.NEW_BUILD_UNIT:
        result.add(ProjectType.NEW_BUILD);
        break;
      case DistributionSubType.NEW_BUILD_INVESTMENT_PRODUCT:
        result.add(ProjectType.INVESTMENT);
        break;
      case DistributionSubType.NEW_BUILD_PROJECT:
        result.add(ProjectType.NEW_BUILD);
        break;
      case DistributionSubType.NEW_HOME:
        result.add(ProjectType.PROJECTED);
        break;
      case DistributionSubType.BUSINESS:
        result.add(ProjectType.STOCK);
        break;
      case DistributionSubType.CLASSIC:
        result.add(ProjectType.STOCK);
        break;
      case DistributionSubType.TEMPORARY:
        result.add(ProjectType.SHORT_TIME_RENTAL);
        break;
      case DistributionSubType.VACATION:
        result.add(ProjectType.SHORT_TIME_RENTAL);
        break;
    }
  }
  result = getSearchProjectTypeWithIsForSwapAdaptation(criterias, result);
  result = getSearchProjectTypeWithIsForFlatsharingAdaptation(criterias, result);
  result = getSearchProjectTypeWithIsSaleGoodwillAdaptation(criterias, result);
  return result.size ? Array.from(result) : void 0;
};
var getSearchProjectTypeWithIsForSwapAdaptation = (criterias, searchCriteria) => {
  if (criterias.distributionType?.includes(DistributionType.RENT) !== true) {
    return searchCriteria;
  }
  if (criterias.estateType?.includes(EstateType.APARTMENT) !== true && criterias.estateType?.includes(EstateType.HOUSE) !== true) {
    return searchCriteria;
  }
  const distributionSubTypes = criterias.distributionSubType ?? [];
  const isForSwap = criterias?.management?.isForSwap;
  const result = new Set(searchCriteria);
  if (isForSwap === true) {
    result.add(ProjectType.SWAP_APARTMENT);
    return result;
  }
  if (isForSwap === false) {
    result.delete(ProjectType.SWAP_APARTMENT);
    return result;
  }
  if (isForSwap === void 0 && distributionSubTypes.length > 0) {
    result.add(ProjectType.SWAP_APARTMENT);
  }
  return result;
};
var getSearchProjectTypeWithIsForFlatsharingAdaptation = (criterias, searchCriteria) => {
  if (criterias.distributionType?.includes(DistributionType.RENT) !== true) {
    return searchCriteria;
  }
  if (criterias.estateType?.includes(EstateType.APARTMENT) !== true && criterias.estateType?.includes(EstateType.HOUSE) !== true) {
    return searchCriteria;
  }
  const distributionSubTypes = criterias.distributionSubType ?? [];
  const isForFlatsharing = criterias?.management?.isForFlatsharing;
  const result = new Set(searchCriteria);
  if (isForFlatsharing === true) {
    result.add(ProjectType.FLATSHARING);
    return result;
  }
  if (isForFlatsharing === false) {
    result.delete(ProjectType.FLATSHARING);
  }
  if (isForFlatsharing === void 0 && distributionSubTypes.length > 0) {
    result.add(ProjectType.FLATSHARING);
  }
  return result;
};
var SearchSearchTypeToSearchType = /* @__PURE__ */ new Map([
  ["classified", SearchType.classified],
  ["project", SearchType.project]
]);
var getMetadataSearchType = (searchModel) => {
  return SearchSearchTypeToSearchType.get(searchModel.searchType) ?? SearchType.classified;
};
var useForToManagementUseFor = /* @__PURE__ */ new Map([
  [UseFor.LIVING, ManagementUseFor.LIVING],
  [UseFor.MIXED, ManagementUseFor.MIXED],
  [UseFor.COMMERCIAL, ManagementUseFor.COMMERCIAL],
  [UseFor.INDUSTRIAL, ManagementUseFor.INDUSTRIAL],
  [UseFor.OFFICE, ManagementUseFor.OFFICE]
]);
var getCriteriaUseFor = (searchModel) => {
  return searchModel.useFor?.map((useFor) => useForToManagementUseFor.get(useFor)).filter((value) => value !== void 0) ?? [];
};
var managementUseForToUseFor = /* @__PURE__ */ new Map([
  [ManagementUseFor.LIVING, UseFor.LIVING],
  [ManagementUseFor.MIXED, UseFor.MIXED],
  [ManagementUseFor.COMMERCIAL, UseFor.COMMERCIAL],
  [ManagementUseFor.INDUSTRIAL, UseFor.INDUSTRIAL],
  [ManagementUseFor.OFFICE, UseFor.OFFICE]
]);
var getSearchUseFor = (criterias) => {
  const useFor = criterias?.management?.useFor;
  const result = useFor?.map((useFor2) => managementUseForToUseFor.get(useFor2))?.filter((value) => value !== void 0) ?? [];
  return result.length ? result : void 0;
};
var getCriteriaAvailableFrom = (searchModel) => {
  return {
    availableFromMax: searchModel?.availableFromMax,
    includeUnspecified: searchModel?.availableFromIsLooseMode
  };
};
var mapSearchDeliveryTimelineToSavedSearchDeliveryTimeline = /* @__PURE__ */ new Map([
  [DeliveryTimelineType.ALL, DeliveryTimeline.ALL],
  [DeliveryTimelineType.NOW, DeliveryTimeline.NOW],
  [DeliveryTimelineType.SIX_MONTHS_MAX, DeliveryTimeline.SIX_MONTHS_MAX],
  [DeliveryTimelineType.TWELVE_MONTHS_MAX, DeliveryTimeline.TWELVE_MONTHS_MAX],
  [DeliveryTimelineType.TWENTY_FOUR_MONTHS_MAX, DeliveryTimeline.TWENTY_FOUR_MONTHS_MAX]
]);
var getMetadataDeliveryTimeline = (searchModel) => {
  return remapFromMap([searchModel.deliveryTimeline], mapSearchDeliveryTimelineToSavedSearchDeliveryTimeline)[0] ?? DeliveryTimeline.None;
};
var getSearchAvailableFromMax = (savedSearch) => {
  return savedSearch.searchMetadata.deliveryTimeline !== DeliveryTimeline.None ? void 0 : savedSearch.criteria?.management?.availableFrom?.availableFromMax;
};
var getSearchAvailableFromIsLooseMode = (savedSearch) => {
  return savedSearch.searchMetadata.deliveryTimeline !== DeliveryTimeline.None ? void 0 : savedSearch.criteria?.management?.availableFrom?.includeUnspecified;
};
var mapSavedSearchDeliveryTimelineToSearchDeliveryTimeline = /* @__PURE__ */ new Map([
  [DeliveryTimeline.ALL, DeliveryTimelineType.ALL],
  [DeliveryTimeline.NOW, DeliveryTimelineType.NOW],
  [DeliveryTimeline.SIX_MONTHS_MAX, DeliveryTimelineType.SIX_MONTHS_MAX],
  [DeliveryTimeline.TWELVE_MONTHS_MAX, DeliveryTimelineType.TWELVE_MONTHS_MAX],
  [DeliveryTimeline.TWENTY_FOUR_MONTHS_MAX, DeliveryTimelineType.TWENTY_FOUR_MONTHS_MAX]
]);
var getSearchDeliveryTimeline = (savedSearch) => {
  return remapFromMap(
    [savedSearch.searchMetadata.deliveryTimeline],
    mapSavedSearchDeliveryTimelineToSearchDeliveryTimeline
  )[0];
};

// src/Utils/mapping/wl.ts
var getCreateSavedSearchFromFullSearchModel = (fullSearchModel) => {
  const resultModel = {
    title: "",
    externalProperties: {
      channelId: "",
      deviceType: SavedSearchDeviceType.None
    },
    criteria: getSavedSearchCriteria(fullSearchModel.searchModel),
    searchMetadata: getSearchMetadata(fullSearchModel),
    channels: [
      {
        enabled: true,
        channel: SavedSearchNotificationChannel.email
      }
    ]
  };
  return clearObject(resultModel);
};
var getSavedSearchCriteria = (searchModel) => {
  return {
    estateType: getCriteriaEstateType(searchModel),
    estateSubType: getCriteriaEstateSubType(searchModel),
    distributionType: getCriteriaDistributionType(searchModel),
    distributionSubType: getCriteriaDistributionSubType(searchModel),
    prices: {
      currencySymbol: void 0,
      currencyUnit: void 0,
      priceMin: searchModel.priceMin,
      priceMax: searchModel.priceMax,
      brokerageFee: getCriteriaBrokerageFee(searchModel)
    },
    spaces: {
      spaceMeasureSymbol: void 0,
      spaceMeasureUnit: void 0,
      spaceMin: searchModel.spaceMin,
      spaceMax: searchModel.spaceMax,
      plotSpaceMin: searchModel.plotSpaceMin,
      plotSpaceMax: searchModel.plotSpaceMax
    },
    structure: {
      rooms: {
        numberOfRoomsMin: searchModel.numberOfRoomsMin,
        numberOfRoomsMax: searchModel.numberOfRoomsMax,
        numberOfBalconiesMin: searchModel.featuresIncluded?.includes(FeatureType.BALCONY_TERRACE) ? 1 : void 0,
        numberOfTerracesMin: void 0,
        numberOfBedRoomsMin: searchModel.numberOfBedroomsMin,
        numberOfBedRoomsMax: searchModel.numberOfBedroomsMax
      },
      building: {
        locationInBuilding: getCriteriaLocationInBuilding(searchModel),
        bath: getCriteriaBathroom(searchModel),
        kitchen: getCriteriaKitchen(searchModel),
        withView: {
          niceView: void 0,
          withoutOverlooking: void 0
        },
        elevator: getCriteriaElevator(searchModel),
        cellar: getCriteriaCellar(searchModel),
        attic: []
      },
      parkingLots: getCriteriaParkingLots(searchModel)
    },
    conditions: {
      yearOfConstructionMin: searchModel.yearOfConstructionMin,
      yearOfConstructionMax: searchModel.yearOfConstructionMax,
      buildState: getCriteriaBuildState(searchModel),
      energyClass: getCriteriaEnergyCertificateClass(searchModel)
    },
    location: getCriteriaLocation(searchModel),
    management: {
      isRented: getCriteriaIsRented(searchModel),
      isForSwap: getCriteriaIsForSwap(searchModel),
      isForFlatsharing: getCriteriaIsForFlatsharing(searchModel),
      rent: {
        petsAllowed: getCriteriaPetAllowed(searchModel),
        certificateOfEligibilityNeeded: getCriteriaCertificateOfEligibilityNeeded(searchModel)
      },
      useFor: getCriteriaUseFor(searchModel),
      legalNotes: [],
      availableFrom: getCriteriaAvailableFrom(searchModel)
    },
    features: {
      wheelchairUse: getCriteriaWheelchairUse(searchModel),
      garden: getCriteriaGarden(searchModel),
      residential: {
        swimmingPool: getCriteriaSwimmingPool(searchModel),
        assistedLiving: getCriteriaAssistedLiving(searchModel)
      },
      propertyOrientation: [],
      furnished: getCriteriaFurnished(searchModel)
    },
    energy: {
      energyType: getCriteriaEnergyTypes(searchModel)
    },
    vendor: {
      vendorType: getCriteriaVendorType(searchModel),
      mandateType: getCriteriaMandateType(searchModel)
    },
    texts: {
      descriptionKeywords: searchModel.keywords ?? []
    }
  };
};
var getSearchMetadata = (fullSearchModel) => ({
  searchType: getMetadataSearchType(fullSearchModel),
  projectType: getMetadataProjectType(fullSearchModel.searchModel),
  deliveryTimeline: getMetadataDeliveryTimeline(fullSearchModel.searchModel)
});
var reverseWLItemToSearchModel = (item, config) => ({
  searchModel: getSearchModelFromSavedSearch(item),
  brand: config.searchBrand,
  searchType: item.searchMetadata.searchType
});
var getSearchModelFromSavedSearch = (savedSearch) => {
  const criterias = savedSearch.criteria;
  const locationsInBuilding = getSearchLocationsInBuilding(criterias);
  return {
    distributionTypes: getSearchDistributionType(criterias),
    projectTypes: getSearchProjectType(savedSearch),
    estateTypes: getSearchEstateType(criterias),
    estateSubTypes: getSearchEstateSubType(criterias),
    locations: getSearchLocation(criterias),
    buildState: getSearchBuildState(criterias),
    certificateOfEligibilityNeeded: getSearchCertificateOfEligibilityNeeded(criterias),
    energyCertificateClass: getSearchEnergyCertificateClass(criterias),
    featuresIncluded: getSearchFeaturesIncluded(criterias),
    furnished: getSearchFurnished(criterias),
    useFor: getSearchUseFor(criterias),
    energyTypes: getSearchEnergyTypes(criterias),
    locationsInBuildingIncluded: locationsInBuilding.include,
    locationsInBuildingExcluded: locationsInBuilding.exclude,
    priceMin: criterias?.prices?.priceMin ?? void 0,
    priceMax: criterias?.prices?.priceMax ?? void 0,
    numberOfRoomsMin: criterias?.structure?.rooms?.numberOfRoomsMin ?? void 0,
    numberOfRoomsMax: criterias?.structure?.rooms?.numberOfRoomsMax ?? void 0,
    numberOfBedroomsMax: criterias?.structure?.rooms?.numberOfBedRoomsMax ?? void 0,
    numberOfBedroomsMin: criterias?.structure?.rooms?.numberOfBedRoomsMin ?? void 0,
    spaceMin: criterias?.spaces?.spaceMin ?? void 0,
    spaceMax: criterias?.spaces?.spaceMax ?? void 0,
    plotSpaceMin: criterias?.spaces?.plotSpaceMin ?? void 0,
    plotSpaceMax: criterias?.spaces?.plotSpaceMax ?? void 0,
    yearOfConstructionMin: criterias?.conditions?.yearOfConstructionMin ?? void 0,
    yearOfConstructionMax: criterias?.conditions?.yearOfConstructionMax ?? void 0,
    classifiedBusiness: getSearchClassifiedBusiness(criterias),
    isSaleGoodwill: getSearchIsSaleGoodwill(criterias),
    listingsDisplay: void 0,
    availableFromMax: getSearchAvailableFromMax(savedSearch),
    availableFromIsLooseMode: getSearchAvailableFromIsLooseMode(savedSearch),
    deliveryTimeline: getSearchDeliveryTimeline(savedSearch),
    keywords: criterias?.texts?.descriptionKeywords ?? void 0
  };
};
var mockedLegacySavedSearches = [
  {
    baseAttributes: {
      id: "20240702152114911-e76199bb",
      userId: 386462,
      config: {
        searchDisplayName: "Haus zum Kauf in Hamburg",
        locationDisplayName: "Hamburg"
      },
      searchCriteria: {
        pricing: {
          priceMin: 10,
          priceMax: 1e5
        },
        construction: {
          roomCountMin: null,
          roomCountMax: null,
          livingAreaMin: 0,
          livingAreaMax: 1e3
        },
        general: {
          equipment: [],
          estateTypes: ["HAUS"],
          distributionTypes: ["ZWANGSVERSTEIGERUNG"],
          energyCertificateClass: []
        },
        relaxedCriteria: {
          location: 0,
          primaryPriceMax: 0,
          primaryAreaMin: 0,
          relaxEquipmentMode: "IGNORE_NONE" /* None */
        }
      },
      endpoints: [
        {
          channelType: "EMAIL_MESSAGE",
          endpointResourceId: "christoph.semder@immonet.de",
          displayName: "christoph.semder@immonet.de",
          notificationFrequency: {
            type: "IMMEDIATE",
            displayName: "Sofort",
            referenceTimestamp: "2002-02-02T02:02:02Z",
            intervalInMinutes: 5
          }
        }
      ],
      formattedSearchCriteria: ["Haus zum Kauf"],
      origin: "migration-immonet-wl"
    },
    detailedLocationDisplayText: "Hamburg"
  }
];
var mockedLegacySavedSearchesToWLResult = [
  {
    criteria: {
      estateType: [EstateType.HOUSE],
      distributionType: [DistributionType.COMPULSORY_AUCTION],
      distributionSubType: [],
      estateSubType: [],
      energy: {
        energyType: {
          energyHeatForm: [],
          energyHeatMethod: [],
          energySource: [],
          energyGeneration: []
        }
      },
      prices: {
        currencySymbol: "\u20AC",
        currencyUnit: "EUR",
        priceMin: 10,
        priceMax: 1e5,
        brokerageFee: {
          hasFee: HasFee.None
        }
      },
      spaces: {
        spaceMeasureSymbol: "m\xB2",
        spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
        spaceMin: 0,
        spaceMax: 1e3,
        plotSpaceMin: void 0,
        plotSpaceMax: void 0
      },
      location: {
        geometries: { circles: [], polygons: [], travels: [] },
        placeIdInfos: [],
        placeIds: []
      },
      structure: {
        rooms: {
          numberOfRoomsMin: void 0,
          numberOfRoomsMax: void 0,
          numberOfBalconiesMin: void 0,
          numberOfTerracesMin: void 0,
          numberOfBedRoomsMin: void 0,
          numberOfBedRoomsMax: void 0
        },
        building: {
          locationInBuilding: [],
          bath: {
            window: void 0,
            bathtub: void 0
          },
          kitchen: {
            equipment: KitchenEquipment.UNKNOWN
          },
          withView: {},
          elevator: [],
          cellar: Cellar.None,
          attic: []
        },
        parkingLots: {}
      },
      conditions: {
        yearOfConstructionMin: void 0,
        yearOfConstructionMax: void 0,
        buildState: [BuildState.None],
        energyClass: [EnergyClass.A, EnergyClass.B]
      },
      management: {
        isRented: void 0,
        isForSwap: void 0,
        rent: {
          petsAllowed: void 0,
          certificateOfEligibilityNeeded: void 0
        },
        useFor: [],
        legalNotes: [],
        availableFrom: {}
      },
      features: {
        wheelchairUse: false,
        garden: [],
        furnished: Furnished.NO,
        residential: {
          swimmingPool: SwimmingPool.None,
          assistedLiving: AssistedLiving.None
        },
        propertyOrientation: []
      },
      vendor: {
        vendorType: [],
        mandateType: []
      },
      texts: {
        descriptionKeywords: []
      }
    },
    searchMetadata: {
      searchType: SearchType.classified,
      projectType: [],
      deliveryTimeline: DeliveryTimeline.None
    },
    title: "Haus zum Kauf in Hamburg",
    identity: {
      id: "20240702152114911-e76199bb",
      userId: "386462",
      portal: "migration-immonet-wl"
    },
    state: SavedSearchState.enabled,
    metadata: {
      modelVersion: LEGACY_MODEL_VERSION,
      created: "",
      updated: "",
      origin: SavedSearchOrigin.SavedSearch
    },
    channels: [
      {
        channel: SavedSearchNotificationChannel.email,
        enabled: true
      }
    ],
    externalProperties: {
      channelId: "",
      deviceType: SavedSearchDeviceType.None
    },
    relaxedCriteria: {
      isEnabled: false,
      options: {
        locationSearchAreaIncrease: 10,
        priceIncreaseInPercent: 10,
        relaxedCriteriaRemoval: false,
        surfaceDecreaseInPercent: 10
      }
    }
  }
];
var legacySLMock = {
  searchId: 76823,
  title: "Mon futur bien \xE0 : Perpignan (2)",
  frequency: 1,
  isActive: true,
  searchCriterias: [
    "Vente",
    "Appartement",
    "Divers",
    "Immeuble",
    "B\xE2timent",
    "Ch\xE2teau",
    "H\xF4tel particulier",
    "Maison/Villa",
    "Parking/Box",
    "Terrain",
    "Loft/Atelier/Surface",
    "P\xE9niche",
    "Perpignan",
    "entre 20\u20AC et 120000\u20AC",
    "entre 10m\xB2 et 299m\xB2",
    "entre 30m\xB2 et 900m\xB2",
    "Ancien",
    "Neuf",
    "2,3 pi\xE8ces",
    "1,2,3 chambres",
    "Terrasse",
    "Parking ouvert",
    "Box",
    "Cave",
    "Piscine",
    "Balcon",
    "Ascenseur",
    "Acc\xE8s handicap\xE9",
    "Garage"
  ],
  searchQueryString: "basement=1&ci=660136&enterprise=0&epc=A,B&houseboat=1&idtt=2&idtypebien=1,10,11,12,13,14,2,3,4,9&mandatorycommodities=0&naturebien=1,2,4&nb_balconsbtw=1/1&nb_chambres=1,2,3&nb_pieces=2,3&pxbtw=20/120000&si_ascenseur=1&si_boxes=1&si_cave=1&si_handicape=1&si_jardin=1&si_parkings=1&si_piscine=1&si_terrasse=1&sigarage=1&surf_terrainbtw=30/900&surfacebtw=10/299"
};
var legacySLMockAsWL = {
  title: "Mon futur bien \xE0 : Perpignan (2)",
  externalProperties: {
    channelId: "",
    deviceType: SavedSearchDeviceType.None
  },
  state: SavedSearchState.enabled,
  metadata: {
    modelVersion: LEGACY_MODEL_VERSION,
    created: "",
    updated: "",
    origin: SavedSearchOrigin.SavedSearch
  },
  relaxedCriteria: {
    isEnabled: false,
    options: {
      locationSearchAreaIncrease: 10,
      priceIncreaseInPercent: 10,
      relaxedCriteriaRemoval: false,
      surfaceDecreaseInPercent: 10
    }
  },
  identity: {
    id: "76823",
    userId: "1",
    portal: "slg-fra"
  },
  channels: [
    {
      channel: SavedSearchNotificationChannel.email,
      enabled: true
    }
  ],
  criteria: {
    estateType: [EstateType.APARTMENT],
    distributionType: [DistributionType.BUY],
    distributionSubType: [],
    estateSubType: [],
    prices: {
      currencySymbol: "\u20AC",
      currencyUnit: "EUR",
      priceMin: void 0,
      priceMax: void 0,
      brokerageFee: {
        hasFee: HasFee.None
      }
    },
    spaces: {
      spaceMeasureSymbol: "m\xB2",
      spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
      spaceMin: void 0,
      spaceMax: void 0,
      plotSpaceMin: void 0,
      plotSpaceMax: void 0
    },
    location: {
      placeIds: [],
      geometries: {
        circles: [],
        polygons: [],
        travels: []
      },
      placeIdInfos: []
    },
    structure: {
      rooms: {
        numberOfRoomsMin: void 0,
        numberOfRoomsMax: void 0,
        numberOfBalconiesMin: void 0,
        numberOfTerracesMin: void 0,
        numberOfBedRoomsMin: void 0,
        numberOfBedRoomsMax: void 0
      },
      building: {
        locationInBuilding: [],
        bath: {
          window: void 0,
          bathtub: void 0
        },
        kitchen: {
          equipment: KitchenEquipment.UNKNOWN
        },
        withView: {},
        elevator: [],
        cellar: Cellar.None,
        attic: []
      },
      parkingLots: {}
    },
    conditions: {
      yearOfConstructionMax: void 0,
      yearOfConstructionMin: void 0,
      buildState: [],
      energyClass: []
    },
    energy: {
      energyType: {
        energyHeatForm: [],
        energyHeatMethod: [],
        energySource: [],
        energyGeneration: []
      }
    },
    management: {
      isRented: void 0,
      isForSwap: void 0,
      rent: {
        petsAllowed: void 0,
        certificateOfEligibilityNeeded: void 0
      },
      useFor: [],
      legalNotes: [],
      availableFrom: {}
    },
    features: {
      wheelchairUse: void 0,
      garden: [],
      furnished: Furnished.None,
      residential: {
        swimmingPool: SwimmingPool.None,
        assistedLiving: AssistedLiving.None
      },
      propertyOrientation: []
    },
    vendor: {
      vendorType: [],
      mandateType: []
    },
    texts: {
      descriptionKeywords: []
    }
  },
  searchMetadata: {
    searchType: SearchType.classified,
    projectType: [],
    deliveryTimeline: DeliveryTimeline.None
  }
};
var mockedResponseId = "fa7aa6b4-1b1e-4116-a888-aaee9b21bb8c";
var cardList = [
  {
    title: "",
    externalProperties: {
      channelId: "",
      deviceType: SavedSearchDeviceType.None
    },
    criteria: {
      estateType: [EstateType.HOUSE, EstateType.APARTMENT],
      estateSubType: [EstateSubType.MANOR_HOUSE],
      distributionType: [DistributionType.BUY],
      distributionSubType: [DistributionSubType.NEW_HOME],
      prices: {
        currencySymbol: "\u20AC",
        currencyUnit: "EUR",
        priceMin: 0,
        priceMax: 890,
        brokerageFee: {
          hasFee: HasFee.None
        }
      },
      spaces: {
        spaceMeasureSymbol: "m\xB2",
        spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
        spaceMin: 0,
        spaceMax: 110,
        plotSpaceMin: 0,
        plotSpaceMax: 0
      },
      structure: {
        rooms: {
          numberOfRoomsMin: 3,
          numberOfRoomsMax: void 0,
          numberOfBalconiesMin: 0,
          numberOfTerracesMin: void 0,
          numberOfBedRoomsMin: void 0,
          numberOfBedRoomsMax: void 0
        },
        building: {
          locationInBuilding: [],
          bath: {
            window: true,
            bathtub: true
          },
          kitchen: {
            equipment: KitchenEquipment.FULLY_EQUIPPED
          },
          withView: {},
          elevator: [Elevator.ANYKIND],
          cellar: Cellar.ANYKIND,
          attic: []
        },
        parkingLots: {}
      },
      conditions: {
        yearOfConstructionMin: void 0,
        yearOfConstructionMax: void 0,
        buildState: [],
        energyClass: [EnergyClass.A, EnergyClass.B]
      },
      location: {
        placeIds: ["NBH2DE65467"],
        placeIdInfos: [
          {
            placeId: "NBH2DE65467",
            placeName: "Allerm\xF6he"
          }
        ],
        geometries: {
          circles: [],
          polygons: [],
          travels: []
        }
      },
      management: {
        isRented: false,
        isForSwap: true,
        rent: {
          petsAllowed: true,
          certificateOfEligibilityNeeded: true
        },
        useFor: [ManagementUseFor.LIVING],
        legalNotes: [],
        availableFrom: {}
      },
      features: {
        wheelchairUse: void 0,
        garden: [],
        furnished: Furnished.FULL,
        residential: {
          swimmingPool: SwimmingPool.None,
          assistedLiving: AssistedLiving.None
        },
        propertyOrientation: []
      },
      energy: {
        energyType: {
          energyHeatForm: [],
          energyHeatMethod: [],
          energySource: [],
          energyGeneration: []
        }
      },
      vendor: {
        vendorType: [],
        mandateType: []
      },
      texts: {
        descriptionKeywords: []
      }
    },
    searchMetadata: {
      searchType: SearchType.classified,
      projectType: [],
      deliveryTimeline: DeliveryTimeline.None
    },
    channels: [
      {
        enabled: true,
        channel: SavedSearchNotificationChannel.email
      }
    ]
  },
  {
    title: "",
    externalProperties: {
      channelId: "",
      deviceType: SavedSearchDeviceType.None
    },
    criteria: {
      estateType: [EstateType.HOUSE],
      estateSubType: [],
      distributionType: [DistributionType.BUY],
      distributionSubType: [DistributionSubType.NEW_HOME],
      prices: {
        currencySymbol: "\u20AC",
        currencyUnit: "EUR",
        priceMin: 0,
        priceMax: 1100,
        brokerageFee: {
          hasFee: HasFee.None
        }
      },
      spaces: {
        spaceMeasureSymbol: "m\xB2",
        spaceMeasureUnit: SpaceMeasureUnit.SQUARE_METER,
        spaceMin: 0,
        spaceMax: 150,
        plotSpaceMin: 0,
        plotSpaceMax: 0
      },
      structure: {
        rooms: {
          numberOfRoomsMin: 3,
          numberOfRoomsMax: void 0,
          numberOfBalconiesMin: 1,
          numberOfTerracesMin: void 0,
          numberOfBedRoomsMin: void 0,
          numberOfBedRoomsMax: void 0
        },
        building: {
          locationInBuilding: [LocationInBuilding.ROOF_STOREY_EXCLUDED],
          bath: {},
          elevator: [],
          kitchen: {
            equipment: KitchenEquipment.FULLY_EQUIPPED
          },
          withView: {},
          cellar: Cellar.None,
          attic: []
        },
        parkingLots: {
          numberOfParkingsMin: 1,
          numberOfGaragesMin: void 0
        }
      },
      conditions: {
        yearOfConstructionMin: void 0,
        yearOfConstructionMax: void 0,
        buildState: [BuildState.FULLY_RENOVATED],
        energyClass: [EnergyClass.A, EnergyClass.B]
      },
      location: {
        placeIds: ["NBH2DE65467"],
        placeIdInfos: [
          {
            placeId: "NBH2DE65467",
            placeName: "Allerm\xF6he"
          }
        ],
        geometries: {
          circles: [],
          polygons: [],
          travels: []
        }
      },
      management: {
        isRented: void 0,
        isForSwap: true,
        rent: {
          petsAllowed: true,
          certificateOfEligibilityNeeded: true
        },
        useFor: [ManagementUseFor.LIVING],
        legalNotes: [],
        availableFrom: {}
      },
      features: {
        wheelchairUse: true,
        garden: [Garden.ANYKIND],
        furnished: Furnished.FULL,
        residential: {
          swimmingPool: SwimmingPool.None,
          assistedLiving: AssistedLiving.None
        },
        propertyOrientation: []
      },
      energy: {
        energyType: {
          energyHeatForm: [],
          energyHeatMethod: [],
          energySource: [],
          energyGeneration: []
        }
      },
      vendor: {
        vendorType: [],
        mandateType: []
      },
      texts: {
        descriptionKeywords: []
      }
    },
    searchMetadata: {
      searchType: SearchType.classified,
      projectType: [],
      deliveryTimeline: DeliveryTimeline.None
    },
    channels: [
      {
        enabled: false,
        channel: SavedSearchNotificationChannel.email
      }
    ]
  }
];
var searchModelMock = {
  certificateOfEligibilityNeeded: CertificateOfEligibility.NO,
  featuresIncluded: [FeatureType.PETS_ALLOWED, FeatureType.BALCONY_TERRACE],
  locationsInBuildingExcluded: [],
  locations: [{ type: LocationType.PLACE_ID, placeId: "NBH2DE65467" }],
  estateTypes: [EstateType$1.HOUSE, EstateType$1.APARTMENT],
  distributionTypes: [DistributionType$1.BUY],
  estateSubTypes: [EstateSubType$1.CASTLE, EstateSubType$1.CHALET],
  projectTypes: [ProjectType.SWAP_APARTMENT],
  furnished: [Furnished$1.FULL, Furnished$1.NO],
  energyCertificateClass: ["A", "B"],
  useFor: [UseFor.LIVING],
  buildState: [BuildState$1.NEED_OF_RENOVATION],
  priceMin: 500,
  priceMax: 1e6,
  spaceMin: 50,
  numberOfBedroomsMin: 1,
  plotSpaceMin: 0,
  yearOfConstructionMin: 1995
};
var searchModelWithRadius = {
  ...searchModelMock,
  locations: [{ type: LocationType.RADIUS, placeId: "NBH2DE65467", radius: 10, polyline: "" }]
};
var searchModelWithCommuteTime = {
  ...searchModelMock,
  locations: [
    {
      type: LocationType.COMMUTE,
      placeIds: ["NBH2DE65467"],
      duration: 30,
      mode: CommuteMode.BIKE,
      polylines: []
    }
  ]
};
var ButtonSearchCriteriaMock = {
  searchModel: searchModelMock,
  searchUrl: "?locationIds=113932&marketingtype=1",
  searchType: "classified",
  stage: "dev",
  type: "btn",
  origin: "serp_full_list" /* FULL_LIST */,
  componentId: "button-search-criteria-mock"
};
var redirectTo = (stage, brand, route) => {
  const redirectUrl = `${getBrandHostname(stage, brand)}/${route ?? ""}`;
  window.location.href = redirectUrl;
};
var getListingsLink = (brandConfig, stage, item) => {
  const url = new URL(getBrandHostname(stage, brandConfig.brandId));
  const searchModel = reverseWLItemToSearchModel(item, brandConfig);
  const querystring = mapSearchModelToQueryString(searchModel);
  url.pathname = searchModel.searchType === "project" ? "/project-search" : "/classified-search";
  url.search = querystring.startsWith("?") ? querystring : `?${querystring}`;
  return url.toString();
};
var redirectToLogin = (stage, brand, additionalQueryParams, register) => {
  if (isWindowUndefined()) {
    return;
  }
  const { href, search } = window?.location;
  if (additionalQueryParams && search) {
    additionalQueryParams = "&" + additionalQueryParams;
  } else {
    additionalQueryParams = "";
  }
  const redirectUriParameter = encodeURIComponent(href + additionalQueryParams);
  let signInHostname = getCustomBrandConfig(brand)?.hostnames.signIn;
  if (!signInHostname) {
    return;
  }
  signInHostname = signInHostname.replace("{env}", stage === "live" ? "" : `${stage}-`);
  window.location.href = `${signInHostname}/?${register ? "screen_hint=signup&" : ""}redirect_uri=${redirectUriParameter}`;
};
var getAvUrlPath = () => {
  if (isWindowUndefined()) return "";
  const { pathname, search } = new URL(window.location.href);
  return pathname + search;
};
var getOptinAlert = (emailNotification, pushNotification) => {
  if (emailNotification && pushNotification) {
    return "push-notifications_and_email";
  } else if (emailNotification) {
    return "email";
  } else if (pushNotification) {
    return "push-notifications";
  }
  return "";
};
var getDeviceType = () => {
  if (isWindowUndefined()) return "none";
  const userAgent = navigator.userAgent || window.opera;
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }
  return "web";
};
var mapMethod = (savedSearch) => {
  let method = "none";
  savedSearch.channels.forEach((channel) => {
    if (channel.channel === "email") {
      method = "email";
    }
  });
  return method;
};
var mapDistributionTypeGlobal = (distributionType) => {
  switch (distributionType) {
    case DistributionType.RENT:
      return "1";
    case DistributionType.BUY:
      return "2";
    case DistributionType.BUY_AUCTION:
      return "3";
    case DistributionType.COMPULSORY_AUCTION:
      return "4";
    default:
      return "0";
  }
};
var mapEstateTypeGlobal = (estateType) => {
  switch (estateType) {
    case EstateType.AGRICULTURE_FORESTRY:
      return "av_1";
    case EstateType.APARTMENT:
      return "av_2";
    case EstateType.BUILDING:
      return "av_3";
    case EstateType.GASTRONOMY_HOTEL:
      return "av_4";
    case EstateType.HOUSE:
      return "av_5";
    case EstateType.MISCELLANEOUS:
      return "av_6";
    case EstateType.OFFICE:
      return "av_7";
    case EstateType.PARKING:
      return "av_8";
    case EstateType.PLOT:
      return "av_9";
    case EstateType.PROJECT:
      return "av_10";
    case EstateType.SENIOR:
      return "av_11";
    case EstateType.STORAGE_PRODUCTION:
      return "av_12";
    case EstateType.TRADING:
      return "av_13";
    default:
      return "";
  }
};
var getMedium = () => {
  if (isWindowUndefined()) return "";
  const urlSearchParams = !isWindowUndefined() ? window?.location?.search : "";
  const queryParameters = new URLSearchParams(urlSearchParams);
  return queryParameters.get("m") ?? "";
};

// src/Utils/tracking/index.ts
var eventTypesToBeAbTested = [
  "lead_classified_alert_opened",
  "lead_classified_alert_submit_buy",
  "lead_classified_alert_submit_rent"
];
var shouldBeAbTested = (eventType, origin) => {
  return eventTypesToBeAbTested.includes(eventType) && originTypesToBeAbTested.includes(origin);
};
var mapSavedSearchCommonsThorKeys = (savedSearch, initiative = "wl_ss_web", category = "alert") => {
  const av_initiative = initiative;
  const av_category = category;
  const av_distribution_type_global = mapDistributionTypeGlobal(savedSearch?.criteria?.distributionType[0]);
  const estateType = savedSearch.criteria.estateType?.[0] ?? "";
  const av_estate_type_global = mapEstateTypeGlobal(estateType);
  return {
    av_initiative,
    av_category,
    av_distribution_type_global,
    av_estate_type_global
  };
};
var mapSavedSearchInterestToThorEvent = (savedSearch, eventType) => {
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch),
    event: eventType
  };
};
var mapSavedSearchSubscripionToThorEvent = (savedSearch, eventType, origin = "serp_full_list" /* FULL_LIST */, abTestValue) => {
  const canBeAbTested = shouldBeAbTested(eventType, origin);
  const eventBase = {
    ...mapSavedSearchInterestToThorEvent(savedSearch, eventType),
    av_medium: getMedium(),
    method: mapMethod(savedSearch)
  };
  const av_zone = abTestValue && canBeAbTested ? abTestValue.av_zone : origin;
  const commonProps = {
    ...eventBase,
    av_zone,
    ...canBeAbTested && abTestValue ? { av_ab_test_variant: abTestValue.av_ab_test_variant } : {}
  };
  if (eventType === "lead_classified_alert_opened") {
    return commonProps;
  }
  return {
    event: eventType,
    av_distribution_type_global: eventBase.av_distribution_type_global,
    av_estate_type_global: eventBase.av_estate_type_global,
    method: eventBase.method,
    av_category: eventBase.av_category,
    av_search: getAvSearch(savedSearch),
    av_zone,
    ...canBeAbTested && abTestValue ? { av_ab_test_variant: abTestValue.av_ab_test_variant } : {}
  };
};
var mapSavedSearchDeletedToThorEvent = (savedSearch) => {
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch),
    av_medium: getMedium(),
    event: "lead_classified_alert_unsub"
  };
};
var mapSavedSearchSeePropertiesToThorEvent = (savedSearch) => {
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch),
    link_text: "see_properties",
    event: "see_properties"
  };
};
var mapSavedSearchToogleAlertToThorEvent = (savedSearch, method, eventType) => {
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch),
    method,
    event: eventType
  };
};
var mapSavedSearchEditAlert = (savedSearch, eventType) => {
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch),
    event: eventType
  };
};
var intermediaryMatchingMandateThorEvent = (search, brandConfig, type) => {
  const savedSearch = getCreateSavedSearchFromFullSearchModel({
    searchModel: search,
    searchType: "classified"
  });
  return {
    ...mapSavedSearchCommonsThorKeys(savedSearch, "wl_ss_web", "classified"),
    event: type
  };
};
var getViewProps = ({ data, legacyData, stage, locale, brand, isAuth }) => {
  const av_language = locale.toUpperCase();
  let emailNotification = false;
  let pushNotification = false;
  let uid = "";
  let active_alert = 0;
  if (data && data.length > 0) {
    active_alert = active_alert + data.length;
    for (const record of data) {
      if (uid === "") uid = record.identity.userId;
      for (const endpoint of record.channels) {
        if (endpoint.enabled && endpoint.channel === SavedSearchNotificationChannel.email) emailNotification = true;
        if (endpoint.enabled && endpoint.channel === SavedSearchNotificationChannel.mobile) pushNotification = true;
      }
    }
  }
  if (legacyData && legacyData.length > 0) {
    active_alert = active_alert + legacyData.length;
    for (const record of legacyData) {
      if (uid === "") uid = record.identity.userId;
      for (const endpoint of record.channels) {
        if (endpoint.enabled && endpoint.channel === SavedSearchNotificationChannel.email) emailNotification = true;
        if (endpoint.enabled && endpoint.channel === SavedSearchNotificationChannel.mobile) pushNotification = true;
      }
    }
  }
  const optin_alert = getOptinAlert(emailNotification, pushNotification);
  return {
    av_user: {
      uid,
      active_alert: active_alert.toString(),
      optin_alert,
      status: isAuth ? "logged" : "unlogged"
    },
    av_pagetitle: "saved_alert",
    av_site: getCustomBrandConfig(brand)?.tracking.site,
    av_language,
    av_environment: stage === "live" ? stage : stage === "preview" ? "preprod" : stage,
    av_url_path: getAvUrlPath(),
    av_initiative: "wl_ss_web",
    av_category: "alert",
    av_medium: getMedium(),
    av_platform: "web"
  };
};
var getUserInteractionData = ({
  componentId = "no_component_id_provided_yet",
  page,
  brandId,
  origin
}) => {
  const device = getDeviceType();
  const originUrl = !isWindowUndefined() ? window?.location?.href : "";
  const newOrigin = origin ? origin : page === "lead" ? "leadFormular" : "getAlertButton";
  return {
    componentId,
    origin: newOrigin,
    device,
    brandId,
    originUrl
  };
};
var getUserInteractionDataFromBanner = (brandId, savedSearch) => {
  const device = getDeviceType();
  const originUrl = !isWindowUndefined() ? window?.location?.href : "";
  const datetime = (/* @__PURE__ */ new Date()).getTime();
  return {
    page: "serp",
    position: "AfterLastListing",
    origin: "banner",
    device,
    brandId,
    originUrl,
    eventType: "click",
    datetime,
    content: savedSearch
  };
};
var matchingListTracking = (classifieds, savedSearch, listName) => {
  if (!classifieds || !savedSearch) {
    return void 0;
  }
  const { av_category, av_initiative, av_distribution_type_global, av_estate_type_global } = mapSavedSearchCommonsThorKeys(savedSearch, "wl_ss_web", "classified");
  const items = Object.values(classifieds).map((classified) => classified.tracking).filter((tracking) => tracking !== void 0 && tracking !== null).map((tracking) => ({ ...tracking, list_name: listName }));
  const EVENT_DATA = {
    event: "view_item_list",
    av_items: items,
    av_category,
    av_initiative,
    av_distribution_type_global,
    av_estate_type_global
  };
  return EVENT_DATA;
};
var getTrackingFavorite = (classified, listName) => {
  const tracking = classified.tracking;
  tracking.list_name = listName;
  return tracking;
};
var getAvSearch = (savedSearch) => {
  const { criteria } = savedSearch;
  return {
    location: criteria?.location?.placeIdInfos[0]?.placeName ?? "",
    price_max: criteria?.prices.priceMax ?? void 0,
    price_min: criteria?.prices.priceMin ?? void 0,
    room_nb: criteria?.structure?.rooms?.numberOfRoomsMin ?? void 0,
    nb_bedroom: criteria?.structure?.rooms?.numberOfBedRoomsMin ?? void 0,
    estate_plot_min: criteria?.spaces?.plotSpaceMin ?? void 0,
    estate_plot_max: criteria?.spaces?.plotSpaceMax ?? void 0,
    estate_space_min: criteria?.spaces?.spaceMin ?? void 0,
    estate_space_max: criteria?.spaces?.spaceMax ?? void 0,
    building_year: criteria?.conditions?.yearOfConstructionMin ?? void 0
  };
};
var spacesSymbol = "m\xB2";
var currencySymbol = "\u20AC";
var roomsKey = " Zimmer";
var getRange = (min, max, symbol = "") => {
  if (min && max) {
    return `${min}${symbol} - ${max}${symbol}`;
  } else if (min) {
    return `min ${min}${symbol}`;
  } else if (max) {
    return `max ${max}${symbol}`;
  }
  return ``;
};
var capitalizeFirstLetter = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var energyClassToWording = (energyClass) => {
  switch (energyClass) {
    case EnergyClass.A_PLUS_PLUS:
      return "A++";
    case EnergyClass.A_PLUS:
      return "A+";
    default:
      return energyClass;
  }
};
var mapCriteriaToWording = (item, t) => {
  const { criteria } = item;
  const criteriasArray = [];
  const criteriaCheckboxKey = "savedSearch.criterias.features.checkbox";
  if (criteria?.structure?.parkingLots?.numberOfGaragesMin || criteria?.structure?.parkingLots?.numberOfParkingsMin) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.parking_garage`));
  }
  if (criteria?.structure?.rooms?.numberOfBalconiesMin || criteria?.structure?.rooms?.numberOfTerracesMin) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.balcony_terrace`));
  }
  if (criteria?.features?.garden && criteria?.features?.garden.length !== 0) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.garden`));
  }
  if (criteria?.structure?.building?.bath?.window) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.bathroom_with_window`));
  }
  if (criteria?.structure?.building?.bath?.bathtub) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.bathroom_with_bathtub`));
  }
  if (criteria?.structure?.building?.cellar === Cellar.ANYKIND) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.cellar`));
  }
  if (criteria?.features?.furnished === Furnished.FULL || criteria?.features?.furnished === Furnished.ANYKIND) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.furnished`));
  }
  if (criteria?.structure?.building?.kitchen?.equipment === KitchenEquipment.FULLY_EQUIPPED) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.built_in_kitchen`));
  }
  if (criteria?.management?.isRented === false) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.vacant`));
  }
  if (criteria?.prices?.brokerageFee?.hasFee === HasFee.NO) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.free_of_commission`));
  }
  if (criteria?.features?.wheelchairUse) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.reduced_mobility_access`));
  }
  if (criteria?.structure?.building?.elevator?.length !== 0 && !criteria?.structure?.building?.elevator?.includes(Elevator.None)) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.elevator`));
  }
  if (criteria?.management?.rent?.petsAllowed) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.pets_allowed`));
  }
  if (criteria?.structure?.building?.locationInBuilding && criteria?.structure?.building?.locationInBuilding?.indexOf(LocationInBuilding.GROUNDFLOOR_EXCLUDED) !== -1) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.no_ground_floor`));
  }
  if (criteria?.structure?.building?.locationInBuilding && criteria?.structure?.building?.locationInBuilding?.indexOf(LocationInBuilding.ROOF_STOREY_EXCLUDED) !== -1) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.no_attic_apartment`));
  }
  if (criteria?.management?.rent?.certificateOfEligibilityNeeded) {
    criteriasArray.push(t(`${criteriaCheckboxKey}.certificate_of_eligibility_needed`));
  }
  if (criteria?.conditions?.energyClass) {
    criteria.conditions.energyClass.forEach((energyClass) => {
      criteriasArray.push(energyClassToWording(energyClass));
    });
  }
  return criteriasArray;
};
var getLocationsWording = ({ placeIds, placeIdInfos, geometries: { circles, travels, polygons } }, t, { prefixed = false } = {}) => {
  if (polygons.length) {
    return t(`savedSearch.criterias.location.polygons${prefixed ? "_prefixed" : ""}`);
  }
  const placeNames = placeIdInfos.map((place) => place.placeName);
  const hasLocality = circles.length > 0 || travels.length > 0 || placeIds.length > 0;
  if (hasLocality && placeNames.length === 0) {
    return t(`savedSearch.criterias.location.polygons${prefixed ? "_prefixed" : ""}`);
  }
  const firstCircle = circles[0];
  if (firstCircle) {
    return t(`savedSearch.criterias.location.circles${prefixed ? "_prefixed" : ""}`, {
      replace: {
        placeName: placeNames[0] ?? "",
        radius: firstCircle.radius,
        radiusUnit: firstCircle.radiusUnit
      },
      unsafe_escapeValue: false
    });
  }
  const firstTravel = travels[0];
  if (firstTravel) {
    return t(`savedSearch.criterias.location.travels`, {
      replace: {
        placeName: placeNames[0] ?? "",
        mode: t(`savedSearch.enums.travelMode.${firstTravel.travelMode[0]}_prefixed`),
        duration: firstTravel.travelValue
      },
      unsafe_escapeValue: false
    });
  }
  if (placeIds.length) {
    return t(`savedSearch.criterias.location.places${prefixed ? "_prefixed" : ""}`, {
      count: placeIds.length,
      replace: {
        count: placeIds.length - 1,
        placeName: placeNames[0] ?? ""
      },
      unsafe_escapeValue: false
    });
  }
  return "";
};
var generateSavedSearchTitle = (criteria, t) => {
  const estateTypes = criteria.estateType.map((el) => t(`savedSearch.enums.estateType.${el}`));
  const distributionTypeEnum = criteria.distributionType.includes(DistributionType.RENT) ? DistributionType.RENT : DistributionType.BUY;
  const distributionType = t(`savedSearch.enums.distributionType.${distributionTypeEnum}_prefixed`);
  const location = getLocationsWording(criteria.location, t, { prefixed: true });
  return t(`savedSearch.title.location`, {
    replace: {
      estateTypes,
      distributionType,
      location
    },
    unsafe_escapeValue: false
  }).trim();
};
var includeUpperOrLower = (toCheck, value) => {
  return toCheck.includes(value.toLowerCase()) || toCheck.includes(value.toUpperCase());
};
var getWLItemWording = (item, t) => {
  const { prices, spaces, location } = item.criteria;
  const title = item?.title ? item.title : generateSavedSearchTitle(item.criteria, t);
  const rooms = item.criteria.structure?.rooms;
  const pricesRange = getRange(prices?.priceMin, prices?.priceMax, currencySymbol);
  const spacesRange = getRange(spaces?.spaceMin, spaces?.spaceMax, spacesSymbol);
  let roomsRange = getRange(rooms?.numberOfRoomsMin, rooms?.numberOfRoomsMax, "");
  if (roomsRange.trim().length > 0) {
    roomsRange += roomsKey;
  }
  const criteriasDisplay = mapCriteriaToWording(item, t).join(" \xB7 ");
  const adLocations = getLocationsWording(location, t);
  return { title, pricesRange, spacesRange, roomsRange, criteriasDisplay, adLocations };
};
var getHintType = (search, t, buttonType) => {
  if (buttonType === "animated-search-btn" || buttonType === "icon-animated-search-btn") {
    return {
      type: "hpHint",
      content: {
        title: t("savedSearch.hint.animatedHint.title"),
        text: t("savedSearch.hint.animatedHint.text")
      }
    };
  }
  if (includeCommuteLocation(search.locations)) {
    return {
      type: "travelTime",
      content: {
        title: t("savedSearch.hint.travel_time.title"),
        text: t("savedSearch.hint.travel_time.text")
      }
    };
  }
  return {
    type: "default",
    content: {
      title: t("savedSearch.hint.default.title"),
      text: t("savedSearch.hint.default.text")
    }
  };
};

export { ButtonSearchCriteriaMock, LEGACY_MODEL_VERSION, NotificationsTargetEnum, URL_getWLSavedSearchAnonymous, URL_unsubscribeAllWLChannelAnonymous, URL_updateWLAlternativeAnonymous, URL_updateWLChannelAnonymous, capitalizeFirstLetter, cardList, clearObject, createIntermediaryMatchingMandatePayload, currencySymbol, deleteLegacyIWTSavedSearches, deleteLegacyIWTSavedSearchesAnonymous, deleteLegacySLGAnonymousSavedSearch, deleteLegacySLGSavedSearches, energyClassToWording, formatNumber, generateSavedSearchTitle, getAnonymousLegacyIWTSavedSearch, getAvSearch, getCreateSavedSearchFromFullSearchModel, getHintType, getIWTAnonymousAuthToken, getLegacyIWTSavedSearches, getLegacyParams, getLegacySLGAnonymous, getLegacySLGSavedSearches, getListingsLink, getLocationsWording, getMostRecentSearch, getNumberOfLocations, getParams, getRange, getSavedSearchCriteria, getSearchMetadata, getSearchModelFromSavedSearch, getTrackingFavorite, getUserInteractionData, getUserInteractionDataFromBanner, getViewProps, getWLItemWording, getWLSavedSearchAnonymous, includeCommuteLocation, includeUpperOrLower, intermediaryMatchingMandateThorEvent, isIntermediaryMatchingMandateShowable, isLegacyIWTSavedSearch, isLegacySLGSavedSearch, isLegacySavedSearch, isValidEmail, legacySLMock, legacySLMockAsWL, mapCriteriaToWording, mapLegacyIWTToSavedSearch, mapLegacySLGDataToSavedSearch, mapSavedSearchCommonsThorKeys, mapSavedSearchDeletedToThorEvent, mapSavedSearchEditAlert, mapSavedSearchInterestToThorEvent, mapSavedSearchSeePropertiesToThorEvent, mapSavedSearchSubscripionToThorEvent, mapSavedSearchToogleAlertToThorEvent, matchingListTracking, mockedLegacySavedSearches, mockedLegacySavedSearchesToWLResult, mockedResponseId, redirectTo, redirectToLogin, reverseWLItemToSearchModel, roomsKey, searchModelMock, searchModelWithCommuteTime, searchModelWithRadius, sortByRencency, sortClassifiedsByRecency, spacesSymbol, unsubscribeAllWLChannelAnonymous, updateLegacyIWTNotificationsState, updateLegacyIWTNotificationsStateAnonymous, updateLegacyIWTNotificationsStates, updateLegacyNotificationsStatesAnonymous, updateLegacySLGNotificationsState, updateLegacySLGNotificationsStateAnonymous, updateWLAlternativeAnonymous, updateWLChannelAnonymous, useDebugRerender, useSavedSearch };
//# sourceMappingURL=chunk-5O2ERBGA.mjs.map
//# sourceMappingURL=chunk-5O2ERBGA.mjs.map